<template>
  <div class="pa-4">
    <div v-allowed="'view_growth_data'">
      <v-tabs v-model="activeTab" show-arrows>
        <v-tab :key="'dashboard'" ripple @click="clickTab(0)">{{ $t("message.dashboard") }}</v-tab>
        <v-tab :key="'leads'" ripple @click="clickTab(1)">{{ $t("message.leads") }} ({{ leads.length }})
        </v-tab>
        <v-tab :key="'visitors'" ripple @click="clickTab(2)">{{ $t("message.visitors") }} ({{
          visitors.length
        }})
        </v-tab>
        <v-tab :key="'inquiries'" ripple @click="clickTab(3)">{{ $t("message.inquiries") }} ({{ inquiries.length }})
        </v-tab>
        <v-tab :key="'at_risk'" ripple @click="clickTab(4)">{{ $t("message.at_risk") }} ({{ atRiskTotal }})
        </v-tab>
        <v-tab :key="'affiliates'" ripple @click="clickTab(5)">{{ $t("message.referrals_campaigns") }}
        </v-tab>
        <v-tabs-items v-model="activeTab" class="mt-4">
          <v-tab-item :key="'dashboard'" class="pa-3">
            <div flat class="mb-2">
              <v-card-actions>
                <v-spacer v-if="!isSmallerDisplay()"></v-spacer>
                <v-btn v-if="!isSmallerDisplay()" class="mr-1" @click="navigateTo({
                  name: 'managecustompages',
                })" outlined elevation="0" color="primary" small slot="activator" left>
                  <v-icon>mdi-bookmark-multiple-outline</v-icon>
                  <span>{{ $t("message.custom_pages") }}</span>
                </v-btn>
                <v-menu offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn v-on="on" :block="!isSmallerDisplay() ? false : true" outlined elevation="0" color="primary"
                      small slot="activator" left>
                      <v-icon v-if="!isSmallerDisplay()">mdi-link-variant</v-icon>
                      <v-icon v-else>mdi-dots-vertical</v-icon>
                      <span>{{ isSmallerDisplay() ? $t("message.actions") : $t("message.links") }}</span>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item v-if="isSmallerDisplay()" @click="navigateTo({
                      name: 'managecustompages',
                    })">
                      <v-list-item-title>
                        <v-icon class="mr-1">mdi-bookmark-multiple-outline</v-icon>
                        {{ $t("message.custom_pages") }}
                      </v-list-item-title>
                    </v-list-item>
                    <v-divider v-if="isSmallerDisplay()"></v-divider>
                    <v-list-item @click="openScheduleVisitorQr()">
                      <v-list-item-title>
                        <v-icon class="mr-1">mdi-qrcode</v-icon>
                        {{ $t("message.schedule_visit") }}
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="openScheduleVisitorQr(true)">
                      <v-list-item-title>
                        <v-icon class="mr-1">mdi-link-variant</v-icon>
                        {{ $t("message.schedule_visit") }}
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="openPublicContactQr()">
                      <v-list-item-title>
                        <v-icon class="mr-1">mdi-qrcode</v-icon>
                        {{ $t("message.contact_form") }}
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="openPublicContactQr(true)">
                      <v-list-item-title>
                        <v-icon class="mr-1">mdi-link-variant</v-icon>
                        {{ $t("message.contact_form") }}
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="openInviteMemberQRCode()">
                      <v-list-item-title>
                        <v-icon class="mr-1">mdi-qrcode</v-icon>
                        {{ $t("message.invite_members") }}
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="openInviteMemberQRCode(true)">
                      <v-list-item-title>
                        <v-icon class="mr-1">mdi-link-variant</v-icon>
                        {{ $t("message.invite_members") }}
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="openVisitorWaiverQrCode()">
                      <v-list-item-title>
                        <v-icon class="mr-1">mdi-qrcode</v-icon>
                        {{ $t("message.visitor_waiver") }}
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="openVisitorWaiverQrCode(true)">
                      <v-list-item-title>
                        <v-icon class="mr-1">mdi-link-variant</v-icon>
                        {{ $t("message.visitor_waiver") }}
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="openScheduleQr()">
                      <v-list-item-title>
                        <v-icon class="mr-1">mdi-qrcode</v-icon>
                        {{ $t("message.academy_schedule") }}
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="openScheduleQr(true)">
                      <v-list-item-title>
                        <v-icon class="mr-1">mdi-link-variant</v-icon>
                        {{ $t("message.academy_schedule") }}
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="displayPMPLinks" @click="openPMPQr()">
                      <v-list-item-title>
                        <v-icon class="mr-1">mdi-qrcode</v-icon>
                        {{ $t("message.public_memberships_page") }}
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="displayPMPLinks" @click="openPMPQr(true)">
                      <v-list-item-title>
                        <v-icon class="mr-1">mdi-link-variant</v-icon>
                        {{ $t("message.public_memberships_page") }}
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-card-actions>
              <v-row>
                <v-col cols="12" sm="12" md="4" class="growth-stat">
                  <v-card outlined class="pa-2">
                    <v-card-title class="text-subtitle-1">
                      {{ $t("message.memberships") }} {{ $t("message.this_month").toLowerCase() }}
                      <v-spacer></v-spacer>
                      <v-btn icon small
                        @click="membershipDetailsDialog = true;"><v-icon>mdi-information-outline</v-icon></v-btn>
                    </v-card-title>
                    <v-card-text class="mb-2 text-left stat-number">
                      <v-row>
                        <v-col>
                          <v-icon style="margin-top: -10px" size="29" color="success"
                            v-if="stats.totalMemberships > 0">mdi-arrow-up-drop-circle-outline</v-icon>
                          <v-icon style="margin-top: -10px" size="29" color="error"
                            v-else-if="stats.totalMemberships < 0">mdi-arrow-down-drop-circle-outline</v-icon>
                          {{ Math.abs(stats.totalMemberships) }}
                        </v-col>
                        <v-col class="text-caption text-left pa-0">
                          <div>
                            <v-icon color="success" size="20">mdi-plus</v-icon>
                            {{ Math.abs(stats.newMemberships) }}
                          </div>
                          <div>
                            <v-icon color="error" size="20">mdi-minus</v-icon>
                            {{ Math.abs(stats.cancelledMemberships) }}
                          </div>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="12" sm="12" md="4" class="growth-stat">
                  <v-card outlined class="pa-2">
                    <v-card-title class="text-subtitle-1">
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <span v-bind="attrs" v-on="on">
                            {{ $t("message.avg_conversion_rate") }}
                          </span>
                        </template>
                        <span>{{ $t("message.last_12_months") }}</span>
                      </v-tooltip>
                    </v-card-title>
                    <v-card-text class="text-left mb-2 stat-number">
                      <v-row>
                        <v-col>
                          {{ stats.avgConvertion < 100 ? stats.avgConvertion : 100 }}% </v-col>
                            <v-col class="pa-0">
                              <div v-if="stats.conversionSpline.options" style="height:45px;">
                                <ApexChart style="margin-top:-30px" type="line"
                                  :options="stats.conversionSpline.options" height="100"
                                  :series="stats.conversionSpline.data">
                                </ApexChart>
                              </div>
                            </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="12" sm="12" md="4" class="growth-stat">
                  <v-card outlined class="pa-2">
                    <v-card-title class="text-subtitle-1">
                      {{ $t("message.upcoming_visits") }}
                    </v-card-title>
                    <v-card-text class="text-left mb-2 stat-number">
                      {{ stats.upcomingVisits.length }}
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="12" sm="12" md="4" class="growth-stat">
                  <v-card outlined class="pa-2">
                    <v-card-title class="text-subtitle-1">
                      {{ $t("message.trialing") }}
                    </v-card-title>
                    <v-card-text class="text-left mb-2 stat-number">
                      {{ stats.trialing }}
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="12" sm="12" md="4" class="growth-stat">
                  <v-card outlined class="pa-2">
                    <v-card-title class="text-subtitle-1">
                      {{ $t("message.retention_rate") }}
                      <v-spacer></v-spacer>
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn icon small v-bind="attrs" v-on="on"><v-icon>mdi-information-outline</v-icon></v-btn>
                        </template>
                        <span>{{ $t("message.retention_rate_explained") }}</span>
                      </v-tooltip>
                    </v-card-title>
                    <v-card-text class="text-left mb-2 stat-number">
                      <span :class="stats.retentionRate.colorTheme + '--text'">{{
                        stats.retentionRate.value }}%</span>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="12" sm="12" md="4" class="growth-stat">
                  <v-card outlined class="pa-2">
                    <v-card-title class="text-subtitle-1">
                      <span>
                        {{ $t("message.inquiries") }} {{ $t("message.this_month").toLowerCase() }}
                      </span>
                    </v-card-title>
                    <v-card-text class="text-left mb-2 stat-number">
                      {{ stats.inquiries }}
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </div>
            <div v-if="loadingHome">
              <GraphLoader type="line"></GraphLoader>
              <GraphLoader class="mt-2" type="line"></GraphLoader>
            </div>
            <div v-else>
              <v-card elevation="0">
                <v-row>
                  <v-col>
                    <ApexChart v-if="growthTrendine.options" type="area" :options="growthTrendine.options" height="350"
                      :series="growthTrendine.data"></ApexChart>
                  </v-col>
                </v-row>
              </v-card>
              <v-card elevation="0">
                <v-row>
                  <v-col>
                    <ApexChart v-if="attendanceTrendine.options" type="area" :options="attendanceTrendine.options"
                      height="350" :series="attendanceTrendine.data"></ApexChart>
                  </v-col>
                </v-row>
              </v-card>
            </div>
          </v-tab-item>
          <v-tab-item :key="'leads'" class="pa-3">
            <v-card v-if="!isSmallerDisplay()" flat>
              <v-data-table v-model="selectedItems" item-key="_id" :headers="headersInquiries" :items="filteredLeads"
                show-select class="elevation-0" :no-data-text="$t('message.no_data')" :footer-props="{
                  itemsPerPageText: $t('message.rows_per_page'),
                  itemsPerPageOptions: [25, 50, 75],
                }">
                <template v-slot:top>
                  <v-card-actions class="ml-2">
                    <v-text-field :hide-details="true" dense outlined :label="$t('message.filter_by_name')"
                      v-model="nameLeadFilter">
                    </v-text-field>
                    <v-spacer></v-spacer>
                    <v-menu offset-y>
                      <template v-slot:activator="{ on }">
                        <v-btn v-on="on" outlined elevation="0" color="primary" small slot="activator" left>
                          <v-icon>mdi-dots-vertical</v-icon>
                          <span>{{ $t("message.actions") }}</span>
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-item v-if="!isSmallerDisplay()" @click="displayNewProspectDialog()">
                          <v-list-item-title>
                            <v-icon size="20">mdi-account-plus-outline</v-icon>
                            {{ $t("message.add") }}
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item :disabled="selectedItems.length == 0" @click="openSendEmailDialog()">
                          <v-list-item-title>
                            <v-icon>mdi-email-arrow-right-outline</v-icon>
                            {{ $t("message.send_email") }}
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item :disabled="selectedItems.length == 0" @click="openSendSMSDialog()">
                          <v-list-item-title>
                            <v-icon>mdi-message-processing</v-icon>
                            {{ $t("message.send_sms") }}
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item :disabled="selectedItems.length == 0" @click="tagsDialog = true">
                          <v-list-item-title>
                            <v-icon>mdi-label-multiple-outline</v-icon>
                            {{ $t("message.update_labels") }}
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item v-if="!isSmallerDisplay()" @click="getUsersCSV('leads')">
                          <v-list-item-title>
                            <v-icon size="20">mdi-cloud-download-outline</v-icon>
                            {{ $t("message.download_list") }}
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item v-if="!isSmallerDisplay()" @click="copyPublicContactForm()">
                          <v-list-item-title>
                            <v-icon>mdi-content-copy</v-icon>
                            {{ $t("message.contact_form_link") }}
                          </v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </v-card-actions>
                  <v-card-actions class="ml-2">
                    <v-autocomplete @change="getLeads()" clearable v-if="availableTags && availableTags.length"
                      :loading="loadingList" :items="availableTags" chips multiple v-model="lTagsFilter"
                      :label="$t('message.labels_filter')" dense outlined>
                    </v-autocomplete>
                  </v-card-actions>
                </template>
                <template v-slot:items="{ props }">
                  <v-checkbox v-model="props.selected" primary hide-details></v-checkbox>
                </template>
                <template v-slot:item.name="{ item }">
                  <a @click="
                    navigateTo({
                      name: 'viewvisitor',
                      params: { visitorId: item._id },
                    })
                    ">{{ item.name }}</a>
                </template>
                <template v-slot:item.email="{ item }">
                  <v-icon color="primary" v-if="item.user">mdi-account-circle-outline</v-icon>
                  <a @click="
                    navigateTo({
                      name: 'viewvisitor',
                      params: { visitorId: item._id },
                    })
                    ">{{ item.email }}</a>
                </template>
                <template v-slot:item.created="{ item }">
                  <span v-if="item.created">{{
                    $d(new Date(item.created), "month_day_year", $i18n.locale)
                  }}</span>
                </template>
                <template v-slot:item.addedBy="{ item }">
                  <span v-if="item.addedBy">{{
                    item.addedBy.displayName
                  }}</span>
                </template>
                <template v-slot:item._id="{ item }">
                  <v-menu offset-y>
                    <template v-slot:activator="{ on }">
                      <v-btn v-on="on" fab text small slot="activator" left>
                        <v-icon>mdi-dots-vertical</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item @click.stop="navigateTo({ name: 'calendar', query: { v: item._id } })">
                        <v-list-item-title>
                          <v-icon class="mr-1">mdi-calendar-check</v-icon>
                          {{ $t("message.add_visit") }}
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item icon color="primary" @click="visitorToMemberDialog(item)">
                        <v-list-item-title>
                          <v-icon class="mr-1">mdi-plus-circle-outline</v-icon>
                          {{ $t("message.add_member") }}
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="removeLead(item)">
                        <v-list-item-title>
                          <v-icon class="mr-1">mdi-close-circle-outline</v-icon>
                          {{ $t("message.remove") }}
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </template>
              </v-data-table>
            </v-card>
            <v-card v-else flat>
              <div class="mt-2 mb-2">
                <v-menu offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn block v-on="on" outlined elevation="0" color="primary" mall slot="activator">
                      <v-icon>mdi-dots-vertical</v-icon>
                      <span>{{ $t("message.actions") }}</span>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item @click="displayNewProspectDialog()">
                      <v-list-item-title>
                        <v-icon size="20">mdi-account-plus-outline</v-icon>
                        {{ $t("message.add") }}
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item :disabled="selectedItems.length == 0" @click="openSendEmailDialog()">
                      <v-list-item-title>
                        <v-icon>mdi-email-arrow-right-outline</v-icon>
                        {{ $t("message.send_email") }}
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item :disabled="selectedItems.length == 0" @click="openSendSMSDialog()">
                      <v-list-item-title>
                        <v-icon>mdi-message-processing</v-icon>
                        {{ $t("message.send_sms") }}
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="copyPublicContactForm()">
                      <v-list-item-title>
                        <v-icon>mdi-content-copy</v-icon>
                        {{ $t("message.contact_form_link") }}
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="navigateTo({ name: 'advancedusersearch' })">
                      <v-list-item-title>
                        <v-icon>mdi-filter-multiple-outline</v-icon>
                        {{ $t("message.more_filters") }}
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>
              <v-list v-if="filteredLeads && filteredLeads.length > 0">
                <template v-for="(m, index) in filteredLeads">
                  <v-list-item :key="'lead_' + m._id">
                    <v-list-item-icon>
                      <v-checkbox v-model="selectedItems" :value="m" primary hide-details></v-checkbox>
                    </v-list-item-icon>
                    <v-list-item-content class="text-left">
                      <v-list-item-title>
                        <v-icon class="mr-1" color="primary" v-if="m.user">mdi-account-circle-outline</v-icon>
                        {{ m.name }}
                      </v-list-item-title>
                      <v-list-item-subtitle>
                        <a @click="
                          navigateTo({
                            name: 'viewvisitor',
                            params: { visitorId: m._id },
                          })
                          ">{{ m.email }}</a>
                      </v-list-item-subtitle>
                      <v-list-item-subtitle>
                        {{ $t("message.created") }}:
                        <span v-if="m.created">{{
                          $d(new Date(m.created), "month_day_year", $i18n.locale)
                        }}</span>
                      </v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-menu offset-y>
                        <template v-slot:activator="{ on }">
                          <v-btn v-on="on" fab text small slot="activator" left>
                            <v-icon>mdi-dots-vertical</v-icon>
                          </v-btn>
                        </template>
                        <v-list>
                          <v-list-item @click.stop="navigateTo({ name: 'calendar', query: { v: m._id } })">
                            <v-list-item-title>
                              <v-icon class="mr-1">mdi-calendar-check</v-icon>
                              {{ $t("message.add_visit") }}
                            </v-list-item-title>
                          </v-list-item>
                          <v-list-item icon color="primary" @click="visitorToMemberDialog(m)">
                            <v-list-item-title>
                              <v-icon class="mr-1">mdi-plus-circle-outline</v-icon>
                              {{ $t("message.add_member") }}
                            </v-list-item-title>
                          </v-list-item>
                          <v-list-item @click="removeLead(m)">
                            <v-list-item-title>
                              <v-icon class="mr-1">mdi-close-circle-outline</v-icon>
                              {{ $t("message.remove") }}
                            </v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </v-list-item-action>
                  </v-list-item>
                  <v-divider v-if="index + 1 < filteredLeads.length" :key="index"></v-divider>
                </template>
              </v-list>
            </v-card>
          </v-tab-item>
          <v-tab-item :key="'visitors'">
            <v-card v-if="!isSmallerDisplay()">
              <v-data-table v-model="selectedItems" item-key="_id" :headers="headersVisitors" :items="filteredVisitors"
                show-select class="elevation-1" :no-data-text="$t('message.no_data')" :footer-props="{
                  itemsPerPageText: $t('message.rows_per_page'),
                  itemsPerPageOptions: [25, 50, 75],
                }">
                <template v-slot:top>
                  <v-card-actions class="ml-2">
                    <v-text-field :hide-details="true" dense outlined :label="$t('message.filter_by_name')"
                      v-model="nameVisitorFilter">
                    </v-text-field>
                    <v-spacer></v-spacer>
                    <v-menu offset-y>
                      <template v-slot:activator="{ on }">
                        <v-btn elevation="0" outlined color="primary" v-on="on" small slot="activator" left>
                          <v-icon>mdi-dots-vertical</v-icon>
                          <span>{{ $t("message.actions") }}</span>
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-item :disabled="selectedItems.length == 0" @click="openSendEmailDialog()">
                          <v-list-item-title>
                            <v-icon>mdi-email-arrow-right-outline</v-icon>
                            {{ $t("message.send_email") }}
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item :disabled="selectedItems.length == 0" @click="openSendSMSDialog()">
                          <v-list-item-title>
                            <v-icon>mdi-message-processing</v-icon>
                            {{ $t("message.send_sms") }}
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item :disabled="selectedItems.length == 0" @click="tagsDialog = true">
                          <v-list-item-title>
                            <v-icon>mdi-tag-outline</v-icon>
                            {{ $t("message.add_labels") }}
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="navigateTo({ name: 'advancedusersearch' })">
                          <v-list-item-title>
                            <v-icon>mdi-filter-multiple-outline</v-icon>
                            {{ $t("message.more_filters") }}
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item v-if="!isSmallerDisplay()" @click="getUsersCSV('visitors')">
                          <v-list-item-title>
                            <v-icon size="20">mdi-cloud-download-outline</v-icon>
                            {{ $t("message.download_list") }}
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="openScheduleVisitorQr()">
                          <v-list-item-title>
                            <v-icon>mdi-qrcode</v-icon>
                            {{ $t("message.schedule_visit_qr") }}
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item v-if="!isSmallerDisplay()" @click="copyScheduleVisitUrl()">
                          <v-list-item-title>
                            <v-icon>mdi-content-copy</v-icon>
                            {{ $t("message.copy_schedule_visit") }}
                          </v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </v-card-actions>
                  <v-card-actions class="ml-2">
                    <v-autocomplete clearable @change="getVisitors()" v-if="availableTags && availableTags.length"
                      :loading="loadingList" :items="availableTags" chips multiple v-model="vTagsFilter"
                      :label="$t('message.labels_filter')" dense outlined>
                    </v-autocomplete>
                  </v-card-actions>
                </template>
                <template v-slot:items="{ props }">
                  <v-checkbox v-model="props.selected" primary hide-details></v-checkbox>
                </template>
                <template v-slot:item.name="{ item }">
                  <div v-if="item.user">
                    <span @click="
                      navigateTo({
                        name: 'viewvisitor',
                        params: { visitorId: item._id },
                      })
                      ">{{ item.user.displayName }}</span>
                    <v-icon color="primary" class="ml-1">mdi-account-circle-outline</v-icon>
                  </div>
                  <div v-else>
                    <span @click="
                      navigateTo({
                        name: 'viewvisitor',
                        params: { visitorId: item._id },
                      })
                      ">{{ item.name ? item.name : "n/a" }}</span>
                  </div>
                </template>
                <template v-slot:item.email="{ item }">
                  <span @click="
                    navigateTo({
                      name: 'viewvisitor',
                      params: { visitorId: item._id },
                    })
                    ">
                    {{ item.email }}
                  </span>
                </template>
                <template v-slot:item.source="{ item }">
                  <v-icon v-if="item.source == 'tablet'">mdi-tablet</v-icon>
                  <v-icon v-else-if="item.source == 'public'">mdi-earth</v-icon>
                  <v-icon v-else-if="item.source == 'social'">mdi-cellphone</v-icon>
                  <v-icon v-else-if="item.source == 'admin'">mdi-monitor</v-icon>
                  <span v-else></span>
                </template>
                <template v-slot:item.firstVisit="{ item }">
                  <div v-if="item.firstVisit">
                    <span v-if="new Date(item.firstVisit) > new Date()" class="primary--text">
                      <v-icon size="15" color="accent">mdi-clock-outline</v-icon>
                      {{ $d(new Date(item.firstVisit), "month_day_year", $i18n.locale) }}
                    </span>
                    <span v-else-if="item.lastVisit">
                      {{ $d(new Date(item.lastVisit), "month_day_year", $i18n.locale) }}
                    </span>
                    <v-tooltip top
                      v-if="item.onboardingTransaction && item.onboardingTransaction._id && !item.onboardingTransaction.cancelled">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn small @click="goToTransaction(item.onboardingTransaction._id)" icon v-bind="attrs"
                          v-on="on">
                          <v-icon size="20" :color="item.onboardingTransaction.cancelled ? 'error' : 'gold'">
                            mdi-ticket-confirmation-outline
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $t("message.onboarding_in_process") }}</span>
                    </v-tooltip>
                  </div>
                  <div v-else>
                    <span v-if="item.lastVisit">{{
                      $d(new Date(item.lastVisit), "month_day_year", $i18n.locale)
                    }}</span>
                    <span v-else>{{
                      $d(new Date(item.created), "month_day_year", $i18n.locale)
                    }}</span>
                    <v-tooltip top v-if="item.onboardingTransaction && !item.onboardingTransaction.cancelled">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn small @click="goToTransaction(item.onboardingTransaction._id)" icon v-bind="attrs"
                          v-on="on">
                          <v-icon size="20" :color="item.onboardingTransaction.cancelled ? 'error' : 'gold'">
                            mdi-ticket-confirmation-outline
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $t("message.onboarding_in_process") }}</span>
                    </v-tooltip>
                  </div>
                </template>
                <template v-slot:item._id="{ item }">
                  <v-menu offset-y>
                    <template v-slot:activator="{ on }">
                      <v-btn v-on="on" fab text small slot="activator" left>
                        <v-icon>mdi-dots-vertical</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item
                        v-if="item.onboardingTransaction && item.onboardingTransaction._id && !item.onboardingTransaction.cancelled"
                        @click="goToTransaction(item.onboardingTransaction._id)">
                        <v-list-item-title>
                          <v-icon size="20" :color="'gold'" class="mr-1">mdi-ticket-confirmation-outline</v-icon>
                          {{ $t("message.pending_transaction") }}
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item @click.stop="navigateTo({ name: 'calendar', query: { v: item._id } })">
                        <v-list-item-title>
                          <v-icon class="mr-1">mdi-calendar-check</v-icon>
                          {{ $t("message.add_visit") }}
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item icon color="primary" @click="visitorToMemberDialog(item)">
                        <v-list-item-title>
                          <v-icon class="mr-1">mdi-plus-circle-outline</v-icon>
                          {{ $t("message.add_member") }}
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item icon color="primary" @click="addLead(item)">
                        <v-list-item-title>
                          <v-icon class="mr-1">mdi-chevron-double-up</v-icon>
                          {{ $t("message.promote_to_lead") }}
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item icon color="primary" @click="showArchiveVisitorDialog(item)">
                        <v-list-item-title>
                          <v-icon>mdi-archive-arrow-down-outline</v-icon>
                          {{ $t("message.archive") }}
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </template>
              </v-data-table>
            </v-card>
            <v-card v-else flat>
              <div class="mb-2">
                <v-menu offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn block elevation="0" outlined color="primary" v-on="on" small slot="activator" left>
                      <v-icon>mdi-dots-vertical</v-icon>
                      <span>{{ $t("message.actions") }}</span>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item :disabled="selectedItems.length == 0" @click="openSendEmailDialog()">
                      <v-list-item-title>
                        <v-icon>mdi-email-arrow-right-outline</v-icon>
                        {{ $t("message.send_email") }}
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item :disabled="selectedItems.length == 0" @click="openSendSMSDialog()">
                      <v-list-item-title>
                        <v-icon>mdi-message-processing</v-icon>
                        {{ $t("message.send_sms") }}
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item :disabled="selectedItems.length == 0" @click="tagsDialog = true">
                      <v-list-item-title>
                        <v-icon>mdi-tag-outline</v-icon>
                        {{ $t("message.add_labels") }}
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="navigateTo({ name: 'advancedusersearch' })">
                      <v-list-item-title>
                        <v-icon>mdi-filter-multiple-outline</v-icon>
                        {{ $t("message.more_filters") }}
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="openScheduleVisitorQr()">
                      <v-list-item-title>
                        <v-icon>mdi-qrcode</v-icon>
                        {{ $t("message.schedule_visit_qr") }}
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="copyScheduleVisitUrl()">
                      <v-list-item-title>
                        <v-icon>mdi-content-copy</v-icon>
                        {{ $t("message.copy_schedule_visit") }}
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>
              <v-list v-if="filteredVisitors && filteredVisitors.length > 0">
                <template v-for="(m, index) in filteredVisitors">
                  <v-list-item :key="'visitor_' + m._id">
                    <v-list-item-icon>
                      <v-checkbox v-model="selectedItems" :value="m" primary hide-details></v-checkbox>
                    </v-list-item-icon>
                    <v-list-item-content class="text-left">
                      <v-list-item-title>
                        <a @click="
                          navigateTo({
                            name: 'viewvisitor',
                            params: { visitorId: m._id },
                          })
                          ">{{ m.user ? m.user.displayName : m.name }}</a>
                        <v-icon v-if="m.user" color="secondary" class="ml-1">mdi-account-circle-outline</v-icon>
                      </v-list-item-title>
                      <v-list-item-subtitle>
                        {{ $t("message.visit_date") }}:
                        <div v-if="m.firstVisit && new Date(m.firstVisit) > new Date()">
                          <v-icon class="mr-1" size="15" color="accent">mdi-clock-outline</v-icon>
                          <span>{{
                            $d(new Date(m.firstVisit), "month_day_year", $i18n.locale)
                          }}</span>
                        </div>
                        <span v-else-if="m.lastVisit">{{
                          $d(new Date(m.lastVisit), "month_day_year", $i18n.locale)
                        }}</span>
                        <span v-else>{{
                          $d(new Date(m.created), "month_day_year", $i18n.locale)
                        }}</span>
                      </v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-menu offset-y>
                        <template v-slot:activator="{ on }">
                          <v-btn v-on="on" fab text small slot="activator" left>
                            <v-icon>mdi-dots-vertical</v-icon>
                          </v-btn>
                        </template>
                        <v-list>
                          <v-list-item v-if="m.onboardingTransaction && !m.onboardingTransaction.cancelled"
                            @click="goToTransaction(m.onboardingTransaction._id)">
                            <v-list-item-title>
                              <v-icon size="20" :color="m.onboardingTransaction.completed ? 'success' : 'gold'">
                                mdi-ticket-confirmation-outline
                              </v-icon>
                            </v-list-item-title>
                          </v-list-item>
                          <v-list-item v-else icon color="primary" @click="visitorToMemberDialog(m)">
                            <v-list-item-title>
                              <v-icon size="20">mdi-account-plus-outline</v-icon>
                            </v-list-item-title>
                          </v-list-item>
                          <v-list-item icon color="primary" @click="addLead(m)">
                            <v-list-item-title>
                              <v-icon size="20" class="mr-1">mdi-chevron-double-up</v-icon>
                            </v-list-item-title>
                          </v-list-item>
                          <v-list-item icon color="primary" @click="showArchiveVisitorDialog(m)">
                            <v-list-item-title>
                              <v-icon>mdi-archive-arrow-down-outline</v-icon>
                            </v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </v-list-item-action>
                  </v-list-item>
                  <v-divider v-if="index + 1 < filteredVisitors.length" :key="index"></v-divider>
                </template>
              </v-list>
            </v-card>
          </v-tab-item>
          <v-tab-item :key="'inquiries'">
            <v-card v-if="!isSmallerDisplay()">
              <v-data-table v-model="selectedItems" item-key="_id" :headers="headersInquiries" :loading="loadingList"
                :items="filteredInquiries" show-select class="elevation-1" :no-data-text="$t('message.no_data')"
                :footer-props="{
                  itemsPerPageText: $t('message.rows_per_page'),
                  itemsPerPageOptions: [25, 50, 75],
                }">
                <template v-slot:top>
                  <v-card-actions class="ml-2">
                    <v-text-field :hide-details="true" dense outlined :label="$t('message.filter_by_name')"
                      v-model="nameInquiryFilter">
                    </v-text-field>
                    <v-spacer></v-spacer>
                    <v-menu offset-y>
                      <template v-slot:activator="{ on }">
                        <v-btn v-on="on" outlined elevation="0" color="primary" small slot="activator" left>
                          <v-icon>mdi-dots-vertical</v-icon>
                          <span>{{ $t("message.actions") }}</span>
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-item v-if="!isSmallerDisplay()" @click="displayNewProspectDialog()">
                          <v-list-item-title>
                            <v-icon size="20">mdi-account-plus-outline</v-icon>
                            {{ $t("message.add") }}
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item :disabled="selectedItems.length == 0" @click="openSendEmailDialog()">
                          <v-list-item-title>
                            <v-icon>mdi-email-arrow-right-outline</v-icon>
                            {{ $t("message.send_email") }}
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item :disabled="selectedItems.length == 0" @click="openSendSMSDialog()">
                          <v-list-item-title>
                            <v-icon>mdi-message-processing</v-icon>
                            {{ $t("message.send_sms") }}
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item :disabled="selectedItems.length == 0" @click="tagsDialog = true">
                          <v-list-item-title>
                            <v-icon>mdi-tag-outline</v-icon>
                            {{ $t("message.add_labels") }}
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="copyPublicContactForm()">
                          <v-list-item-title>
                            <v-icon>mdi-content-copy</v-icon>
                            {{ $t("message.contact_form_link") }}
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="openPublicContactQr()">
                          <v-list-item-title>
                            <v-icon>mdi-qrcode</v-icon>
                            {{ $t("message.contact_form_qr") }}
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="navigateTo({ name: 'advancedusersearch' })">
                          <v-list-item-title>
                            <v-icon>mdi-filter-multiple-outline</v-icon>
                            {{ $t("message.more_filters") }}
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item v-if="!isSmallerDisplay()" @click="getUsersCSV('inquiries')">
                          <v-list-item-title>
                            <v-icon size="20">mdi-cloud-download-outline</v-icon>
                            {{ $t("message.download_list") }}
                          </v-list-item-title>
                        </v-list-item><v-list-item v-if="!isSmallerDisplay() && isAppAdmin($store.state.user._id)"
                          @click="showUploadDialog()">
                          <v-list-item-title>
                            <v-icon size="20">mdi-cloud-upload-outline</v-icon>
                            {{ $t("message.upload_list") }}
                          </v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </v-card-actions>
                  <v-card-actions class="ml-2">
                    <v-autocomplete @change="getInquiries()" clearable v-if="availableTags && availableTags.length"
                      :loading="loadingList" :items="availableTags" chips multiple v-model="iTagsFilter"
                      :label="$t('message.labels_filter')" dense outlined>
                    </v-autocomplete>
                  </v-card-actions>
                </template>
                <template v-slot:items="{ props }">
                  <v-checkbox v-model="props.selected" primary hide-details></v-checkbox>
                </template>
                <template v-slot:item.name="{ item }">
                  <a @click="
                    navigateTo({
                      name: 'viewvisitor',
                      params: { visitorId: item._id },
                    })
                    ">{{ item.name }}</a>
                </template>
                <template v-slot:item.email="{ item }">
                  <v-icon class="mr-1" color="primary" v-if="item.user">mdi-account-circle-outline</v-icon>
                  <a @click="
                    navigateTo({
                      name: 'viewvisitor',
                      params: { visitorId: item._id },
                    })
                    ">{{ item.email }}</a>
                </template>
                <template v-slot:item.created="{ item }">
                  <span v-if="item.created">{{
                    $d(new Date(item.created), "short", $i18n.locale)
                  }}</span>
                </template>
                <template v-slot:item.addedBy="{ item }">
                  <span v-if="item.addedBy">{{
                    item.addedBy.displayName
                  }}</span>
                </template>
                <template v-slot:item._id="{ item }">
                  <v-menu offset-y>
                    <template v-slot:activator="{ on }">
                      <v-btn v-on="on" fab text small slot="activator" left>
                        <v-icon>mdi-dots-vertical</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item @click.stop="navigateTo({ name: 'calendar', query: { v: item._id } })">
                        <v-list-item-title>
                          <v-icon class="mr-1">mdi-calendar-check</v-icon>
                          {{ $t("message.add_visit") }}
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item icon color="primary" @click="prospectToMemberDialog(item)">
                        <v-list-item-title>
                          <v-icon class="mr-1">mdi-plus-circle-outline</v-icon>
                          {{ $t("message.add_member") }}
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item v-if="!item.user || !item.user.academyId" icon color="primary"
                        @click="showProspectToVisitorDialog(item)">
                        <v-list-item-title>
                          <v-icon class="mr-1">mdi-chevron-up</v-icon>
                          {{ $t("message.promote_to_visitor") }}
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item icon color="primary" @click="addLead(item)">
                        <v-list-item-title>
                          <v-icon class="mr-1">mdi-chevron-double-up</v-icon>
                          {{ $t("message.promote_to_lead") }}
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="removeProspect(item)">
                        <v-list-item-title>
                          <v-icon class="mr-1">mdi-close-circle-outline</v-icon>
                          {{ $t("message.remove") }}
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </template>
              </v-data-table>
            </v-card>
            <v-card v-else>
              <div class="mt-2 mb-2">
                <v-menu offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn block v-on="on" outlined elevation="0" color="primary" mall slot="activator">
                      <v-icon>mdi-dots-vertical</v-icon>
                      <span>{{ $t("message.actions") }}</span>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item @click="displayNewProspectDialog()">
                      <v-list-item-title>
                        <v-icon size="20">mdi-account-plus-outline</v-icon>
                        {{ $t("message.add") }}
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item :disabled="selectedItems.length == 0" @click="openSendEmailDialog()">
                      <v-list-item-title>
                        <v-icon>mdi-email-arrow-right-outline</v-icon>
                        {{ $t("message.send_email") }}
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item :disabled="selectedItems.length == 0" @click="openSendSMSDialog()">
                      <v-list-item-title>
                        <v-icon>mdi-message-processing</v-icon>
                        {{ $t("message.send_sms") }}
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item :disabled="selectedItems.length == 0" @click="tagsDialog = true">
                      <v-list-item-title>
                        <v-icon>mdi-tag-outline</v-icon>
                        {{ $t("message.add_labels") }}
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="navigateTo({ name: 'advancedusersearch' })">
                      <v-list-item-title>
                        <v-icon>mdi-filter-multiple-outline</v-icon>
                        {{ $t("message.more_filters") }}
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="copyPublicContactForm()">
                      <v-list-item-title>
                        <v-icon>mdi-content-copy</v-icon>
                        {{ $t("message.contact_form_link") }}
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>
              <v-list v-if="filteredInquiries && filteredInquiries.length > 0">
                <template v-for="(m, index) in filteredInquiries">
                  <v-list-item :key="'inquiry_' + m._id">
                    <v-list-item-icon>
                      <v-checkbox v-model="selectedItems" :value="m" primary hide-details></v-checkbox>
                    </v-list-item-icon>
                    <v-list-item-content class="text-left">
                      <v-list-item-title>
                        <v-icon color="primary" v-if="m.user">mdi-account-circle-outline</v-icon>
                        {{ m.name }}
                      </v-list-item-title>
                      <v-list-item-subtitle>
                        <a @click="
                          navigateTo({
                            name: 'viewvisitor',
                            params: { visitorId: m._id },
                          })
                          ">{{ m.email }}</a>
                      </v-list-item-subtitle>
                      <v-list-item-subtitle>
                        {{ $t("message.created") }}:
                        <span v-if="m.created">{{
                          $d(new Date(m.created), "month_day_year", $i18n.locale)
                        }}</span>
                      </v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-menu offset-y>
                        <template v-slot:activator="{ on }">
                          <v-btn v-on="on" fab text small slot="activator" left>
                            <v-icon>mdi-dots-vertical</v-icon>
                          </v-btn>
                        </template>
                        <v-list>
                          <v-list-item icon color="primary" @click="prospectToMemberDialog(m)">
                            <v-list-item-title>
                              <v-icon size="20">mdi-plus-circle-outline</v-icon>
                            </v-list-item-title>
                          </v-list-item>
                          <v-list-item v-if="!m.user || !m.user.academyId" icon color="primary"
                            @click="showProspectToVisitorDialog(m)">
                            <v-list-item-title>
                              <v-icon size="20">mdi-chevron-up</v-icon>
                            </v-list-item-title>
                          </v-list-item>
                          <v-list-item icon color="primary" @click="addLead(m)">
                            <v-list-item-title>
                              <v-icon size="20" class="mr-1">mdi-chevron-double-up</v-icon>
                            </v-list-item-title>
                          </v-list-item>
                          <v-list-item @click="removeProspect(m)">
                            <v-list-item-title>
                              <v-icon>mdi-close-circle-outline</v-icon>
                            </v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </v-list-item-action>
                  </v-list-item>
                  <v-divider v-if="index + 1 < filteredInquiries.length" :key="index"></v-divider>
                </template>
              </v-list>
            </v-card>
          </v-tab-item>
          <v-tab-item :key="'at_risk'" class="pa-3">
            <v-card v-if="!isSmallerDisplay()" flat>
              <v-data-table :loading="loadingAtRisk" v-model="selectedItems" item-key="id" :headers="headersAtRisk"
                :items="filteredAtRisk" show-select class="elevation-0" :no-data-text="$t('message.no_data')"
                :footer-props="{
                  itemsPerPageText: $t('message.rows_per_page'),
                  itemsPerPageOptions: [25, 50, 75],
                }">
                <template v-slot:top>
                  <v-card-actions class="ml-2">
                    <v-text-field :hide-details="true" dense outlined :label="$t('message.filter_by_name')"
                      v-model="nameAtRiskFilter">
                    </v-text-field>
                    <v-spacer></v-spacer>
                    <v-menu offset-y>
                      <template v-slot:activator="{ on }">
                        <v-btn elevation="0" outlined color="primary" v-on="on" small slot="activator" left>
                          <v-icon>mdi-dots-vertical</v-icon>
                          <span>{{ $t("message.actions") }}</span>
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-item :disabled="selectedItems.length == 0" @click="openSendEmailDialog()">
                          <v-list-item-title>
                            <v-icon>mdi-email-arrow-right-outline</v-icon>
                            {{ $t("message.send_email") }}
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item :disabled="selectedItems.length == 0" @click="openSendSMSDialog()">
                          <v-list-item-title>
                            <v-icon>mdi-message-processing</v-icon>
                            {{ $t("message.send_sms") }}
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item :disabled="selectedItems.length == 0" @click="tagsDialog = true">
                          <v-list-item-title>
                            <v-icon>mdi-tag-outline</v-icon>
                            {{ $t("message.add_labels") }}
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item v-show="false" @click="updateAttendanceAlertPercentDialog = true">
                          <v-list-item-title>
                            <v-icon>mdi-pencil-box-outline</v-icon>
                            {{ $t("message.attendance_alerts_percent") }}
                          </v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </v-card-actions>
                  <v-card-actions>
                    <v-slider thumb-color="accent" :disabled="loadingAtRisk" @change="getAtRisk()"
                      :label="$t('message.selected_days')" thumb-label="always" step="1" v-model="atRiskDays" max="60"
                      min="7" hide-details></v-slider>
                  </v-card-actions>
                </template>
                <template v-slot:items="{ props }">
                  <v-checkbox v-model="props.selected" primary hide-details></v-checkbox>
                </template>
                <template v-slot:item.email="{ item }">
                  <a @click="goToMember(item.id, item.name)">{{ item.email }}</a>
                </template>
                <template v-slot:item.name="{ item }">
                  <div @click="goToMember(item.id, item.name)">
                    <v-avatar class="mr-1" size="20">
                      <ImageDisplay v-if="item.userImageSmall" :src="item.userImageSmall" />
                      <img v-else :src="assets() + '/default-profile-avatar.png'" />
                    </v-avatar>
                    {{ item.name }}
                  </div>
                </template>
                <template v-slot:item.checkin="{ item }">
                  {{ $d(new Date(item.checkin), "month_day_year", $i18n.locale) }}
                </template>
                <template v-slot:item.className="{ item }">
                  {{ item.className }}
                </template>
                <template v-slot:item._id="{ item }">
                  <v-menu offset-y>
                    <template v-slot:activator="{ on }">
                      <v-btn v-on="on" fab text small slot="activator" left>
                        <v-icon>mdi-dots-vertical</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item icon color="primary" @click="removeAtRisk(item)">
                        <v-list-item-title>
                          <v-icon class="mr-1">mdi-close-circle-outline</v-icon>
                          {{ $t("message.remove") }}
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </template>
              </v-data-table>
            </v-card>
            <v-card v-else flat>
              <div class="mt-2 mb-2">
                <v-menu offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn block elevation="0" outlined color="primary" v-on="on" small slot="activator" left>
                      <v-icon>mdi-dots-vertical</v-icon>
                      <span>{{ $t("message.actions") }}</span>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item :disabled="selectedItems.length == 0" @click="openSendEmailDialog()">
                      <v-list-item-title>
                        <v-icon>mdi-email-arrow-right-outline</v-icon>
                        {{ $t("message.send_email") }}
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item :disabled="selectedItems.length == 0" @click="openSendSMSDialog()">
                      <v-list-item-title>
                        <v-icon>mdi-message-processing</v-icon>
                        {{ $t("message.send_sms") }}
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item :disabled="selectedItems.length == 0" @click="tagsDialog = true">
                      <v-list-item-title>
                        <v-icon>mdi-tag-outline</v-icon>
                        {{ $t("message.add_labels") }}
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item v-show="false" @click="updateAttendanceAlertPercentDialog = true">
                      <v-list-item-title>
                        <v-icon>mdi-pencil-box-outline</v-icon>
                        {{ $t("message.attendance_alerts_percent") }}
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>
              <v-list v-if="filteredAtRisk && filteredAtRisk.length > 0">
                <template v-for="(m, index) in filteredAtRisk">
                  <v-list-item :key="'atrisky_' + m._id" @click="goToMember(m.id, m.name)">
                    <v-list-item-icon>
                      <v-checkbox v-model="selectedItems" :value="m" primary hide-details></v-checkbox>
                    </v-list-item-icon>
                    <v-list-item-content class="text-left">
                      <v-list-item-title>
                        <v-avatar class="mr-1" size="20">
                          <ImageDisplay v-if="m.userImageSmall" :src="m.userImageSmall" />
                          <img v-else :src="assets() + '/default-profile-avatar.png'" />
                        </v-avatar>
                        {{ m.name }}
                      </v-list-item-title>
                      <v-list-item-subtitle>
                        {{ m.days }} {{ $t("message.days") }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-menu offset-y>
                        <template v-slot:activator="{ on }">
                          <v-btn v-on="on" fab text small slot="activator" left>
                            <v-icon>mdi-dots-vertical</v-icon>
                          </v-btn>
                        </template>
                        <v-list>
                          <v-list-item icon color="primary" @click="removeAtRisk(m)">
                            <v-list-item-title>
                              <v-icon size="20" class="mr-1">mdi-plus-circle-outline</v-icon>
                              {{ $t("message.remove") }}
                            </v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </v-list-item-action>
                  </v-list-item>
                  <v-divider v-if="index + 1 < filteredAtRisk.length" :key="index"></v-divider>
                </template>
              </v-list>
            </v-card>
          </v-tab-item>
          <v-tab-item :key="'affiliates'" class="pa-3">
            <v-expansion-panels class="mt-2" flat>
              <v-expansion-panel :class="$store.state.theme == 'light' ? 'border-light' : 'border-dark'">
                <v-expansion-panel-header>
                  <div class="text-left">
                    {{ $t("message.campaigns") }} ({{ campaigns.length }})
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-autocomplete @change="getCampaignDetails()" v-if="campaigns && campaigns.length" :items="campaigns"
                    v-model="selectedCampaign" :label="$t('message.campaign')" dense outlined>
                  </v-autocomplete>
                  <v-card-text v-else>
                    {{ $t('message.add_affiliate_to_see') }}
                  </v-card-text>
                  <v-card elevation="0" v-if="selectedCampaign">
                    <v-card-actions>
                      <v-btn color="primary" outlined small elevation="0"
                        @click="navigateTo(({ name: 'manageaffiliate', query: { c: selectedCampaign }, params: { id: 'new_affiliate' } }))">
                        <v-icon>mdi-plus-circle-outline</v-icon>
                        <span class="ml-1" v-if="!isSmallerDisplay()">{{ $t('message.add_entry') }}</span>
                      </v-btn>
                      <v-btn color="primary" outlined small elevation="0"
                        @click="confirmBulkCampiagnUpdate(selectedCampaign)">
                        <v-icon>mdi-check-all</v-icon>
                        <span class="ml-1" v-if="!isSmallerDisplay()">{{ $t('message.activate_all') }}</span>
                      </v-btn>
                      <v-btn color="primary" outlined small elevation="0"
                        @click="confirmBulkCampiagnUpdate(selectedCampaign)">
                        <v-icon>mdi-delete-sweep-outline</v-icon>
                        <span class="ml-1" v-if="!isSmallerDisplay()">{{ $t('message.deactivate_all') }}</span>
                      </v-btn>
                      <v-spacer></v-spacer>
                      <v-btn icon small elevation="0" @click="getCampaignDetails()">
                        <v-icon>mdi-refresh</v-icon>
                      </v-btn>
                    </v-card-actions>
                    <v-card-text v-if="campaignData">
                      <div v-if="!isSmallerDisplay()">
                        <v-row no-gutters>
                          <v-col cols="4">
                            <v-card class="pa-2" tile elevation="0">
                              <ApexChart width="100%" height="200"
                                v-if="campaignData.referrals && campaignData.referralsTotal > 0" type="pie"
                                :options="campaignData.referrals.options" :series="campaignData.referrals.data">
                              </ApexChart>
                              <div v-else class="text-h5">
                                {{ $t('message.no_referrals') }}
                                {{ campaignData.referrals.referralsTotal }}
                              </div>
                            </v-card>
                          </v-col>
                          <v-col cols="8">
                            <v-card elevation="0" class="pa-2" tile>
                              <ApexChart width="100%" type="area" height="200" :options="campaignData.trendline.options"
                                :series="campaignData.trendline.data"></ApexChart>
                            </v-card>
                          </v-col>
                        </v-row>
                      </div>
                      <div v-else>
                        <v-card class="mb-1" tile elevation="0">
                          <ApexChart width="100%" height="200"
                            v-if="campaignData.referrals && campaignData.referralsTotal > 0" type="pie"
                            :options="campaignData.referrals.options" :series="campaignData.referrals.data">
                          </ApexChart>
                          <div v-else class="text-h5">
                            {{ $t('message.no_referrals') }}
                          </div>
                        </v-card>
                        <v-card elevation="0" tile>
                          <ApexChart width="100%" type="area" height="200" :options="campaignData.trendline.options"
                            :series="campaignData.trendline.data"></ApexChart>
                        </v-card>
                      </div>
                      <div v-if="campaignData.tops">
                        <v-list>
                          <v-subheader>{{ $t('message.top_performers') }}</v-subheader>
                          <template v-for="(i, index) in campaignData.tops">
                            <v-list-item :key="'affilate_top__' + i._id">
                              <v-list-item-avatar>
                                <ImageDisplay v-if="i.image" :src="i.image" />
                                <img v-else :src="assets('default-profile-avatar.png')" />
                              </v-list-item-avatar>
                              <v-list-item-content class="text-left">
                                <v-list-item-title>
                                  {{ i.name }}
                                </v-list-item-title>
                                <v-list-item-subtitle>
                                  <b>{{ i.totalReferrals }}</b> {{ $t('message.referrals') }}
                                </v-list-item-subtitle>
                              </v-list-item-content>
                            </v-list-item>
                            <v-divider v-if="index + 1 < campaignData.tops.length" :key="index"></v-divider>
                          </template>
                        </v-list>
                      </div>
                    </v-card-text>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
            <v-card elevation="0" v-if="!isSmallerDisplay()">
              <v-data-table v-model="selectedItems" item-key="_id" :headers="headersAffiliates" :loading="loadingList"
                :items="filteredAffiliates" show-select class="elevation-0" :no-data-text="$t('message.no_data')"
                :footer-props="{
                  itemsPerPageText: $t('message.rows_per_page'),
                  itemsPerPageOptions: [25, 50, 75],
                }">
                <template v-slot:top>
                  <v-card-actions class="ml-2">
                    <v-text-field :hide-details="true" dense outlined :label="$t('message.filter_by_name_or_campaign')"
                      v-model="nameAffiliateFilter">
                    </v-text-field>
                    <v-spacer></v-spacer>
                    <v-menu offset-y>
                      <template v-slot:activator="{ on }">
                        <v-btn v-on="on" outlined elevation="0" color="primary" small slot="activator" left>
                          <v-icon>mdi-dots-vertical</v-icon>
                          <span>{{ $t("message.actions") }}</span>
                        </v-btn>
                      </template>
                      <v-list>
                        <v-list-item v-if="!isSmallerDisplay()"
                          @click="navigateTo(({ name: 'manageaffiliate', params: { id: 'new_affiliate' } }))">
                          <v-list-item-title>
                            <v-icon size="20">mdi-account-plus-outline</v-icon>
                            {{ $t("message.add") }}
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item :disabled="selectedItems.length == 0" @click="openSendEmailDialog()">
                          <v-list-item-title>
                            <v-icon>mdi-email-arrow-right-outline</v-icon>
                            {{ $t("message.send_email") }}
                          </v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </v-card-actions>
                </template>
                <template v-slot:items="{ props }">
                  <v-checkbox v-model="props.selected" primary hide-details></v-checkbox>
                </template>
                <template v-slot:item.name="{ item }">
                  <v-avatar class="mr-1" size="20">
                    <ImageDisplay v-if="item.image" :src="item.image" />
                    <img v-else :src="assets() + '/default-profile-avatar.png'" />
                  </v-avatar>
                  <a @click="
                    navigateTo({
                      name: 'manageaffiliate',
                      params: { id: item._id },
                    })
                    ">{{ item.name }}</a>
                </template>
                <template v-slot:item.email="{ item }">
                  <v-btn small text @click="copyToClipboard(item.email)">
                    {{ item.email }}</v-btn>
                </template>
                <template v-slot:item.createdAt="{ item }">
                  <span v-if="item.createdAt">{{
                    $d(new Date(item.createdAt), "month_day_year", $i18n.locale)
                  }}</span>
                </template>
                <template v-slot:item.interactions="{ item }">
                  {{ item.interactions }}
                </template>
                <template v-slot:item.referrals="{ item }">
                  {{ item.converted }}/{{ item.referrals }}
                </template>
                <template v-slot:item.totalPaid="{ item }">
                  {{ currencySymbol }}{{ item.totalPaid }}
                </template>
                <template v-slot:item.active="{ item }">
                  <v-icon size="20" color="success" v-if="item.active">mdi-check-circle-outline</v-icon>
                  <v-icon size="20" color="error"
                    v-else-if="!item.active && item.expirationDate">mdi-timer-sand-complete</v-icon>
                  <v-icon size="20" color="error" v-else>mdi-close-circle-outline</v-icon>
                </template>
              </v-data-table>
            </v-card>
            <v-card elevation="0" v-else>
              <div class="mt-2 mb-2">
                <v-menu offset-y>
                  <template v-slot:activator="{ on }">
                    <v-btn block v-on="on" outlined elevation="0" color="primary" mall slot="activator">
                      <v-icon>mdi-dots-vertical</v-icon>
                      <span>{{ $t("message.actions") }}</span>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item @click="navigateTo(({ name: 'manageaffiliate', params: { id: 'new_affiliate' } }))">
                      <v-list-item-title>
                        <v-icon size="20">mdi-account-plus-outline</v-icon>
                        {{ $t("message.add") }}
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item :disabled="selectedItems.length == 0" @click="openSendEmailDialog()">
                      <v-list-item-title>
                        <v-icon>mdi-email-arrow-right-outline</v-icon>
                        {{ $t("message.send_email") }}
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
                <div class="mt-2">
                  <v-text-field :hide-details="true" dense outlined :label="$t('message.filter_by_name_or_campaign')"
                    v-model="nameAffiliateFilter">
                  </v-text-field>
                </div>
                <v-list v-if="filteredAffiliates && filteredAffiliates.length > 0">
                  <template v-for="(m, index) in filteredAffiliates">
                    <v-list-item :key="'affiliate_' + m._id">
                      <v-list-item-icon>
                        <v-checkbox v-model="selectedItems" :value="m" primary hide-details></v-checkbox>
                      </v-list-item-icon>
                      <v-list-item-content class="text-left">
                        <v-list-item-title>
                          <v-avatar class="mr-1" size="20">
                            <ImageDisplay v-if="m.image" :src="m.image" />
                            <img v-else :src="assets() + '/default-profile-avatar.png'" />
                          </v-avatar>
                          {{ m.name }}
                        </v-list-item-title>
                        <v-list-item-subtitle>
                          <a @click="
                            navigateTo({
                              name: 'manageaffiliate',
                              params: { id: m._id },
                            })
                            ">{{ m.email }}</a>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider v-if="index + 1 < filteredInquiries.length" :key="index"></v-divider>
                  </template>
                </v-list>
              </div>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-tabs>
    </div>
    <v-dialog v-model="newProspectDialog" max-width="90%">
      <v-card outlined>
        <v-card-text>
          <div>
            <v-autocomplete item-text="text" item-value="value" clearable
              v-if="archivedInquiries && archivedInquiries.length" :items="archivedInquiries" chips
              v-model="archivedInquiry" :label="$t('message.archived')" dense outlined>
            </v-autocomplete>
          </div>
          <div v-show="!archivedInquiry">
            <v-text-field class="mt-6" :label="$t('message.name') + '*'" v-model="newProspect.name" autocomplete="false"
              required outlined dense></v-text-field>
            <v-text-field label="Email*" v-model="newProspect.email" required outlined dense></v-text-field>
            <gender-select :icon="false" v-model="newProspect.gender" />
            <CountriesSelect :show-icon="false" v-model="newProspect.nationality" />
            <v-text-field :label="$t('message.phone')" v-model="newProspect.phone" autocomplete="false" required
              outlined dense></v-text-field>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn :loading="addingInquiry" outlined elevation="0" color="primary" small @click="addNewProspect()">
            {{ $t('message.add') }}
          </v-btn>
          <v-btn elevation="0" small @click="newProspectDialog = false">
            {{ $t('message.close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="prospectToVisitorDialog" max-width="80%">
      <v-card class="pa-2" outlined>
        <v-card-title>
          {{ $t("message.promote_inquiry_to_visitor") }}
        </v-card-title>
        <v-card-text class="invite-link">
          <div class="mb-4">
            {{ $t("message.visit_date") }}
          </div>
          <div class="truncate-text">
            <DatePicker v-model="newVisitDate"></DatePicker>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn outlined :disabled="!newVisitDate" small elevation="0" color="primary"
            @click.stop="prospectToVisitor()">
            <v-icon class="mr-1">mdi-chevron-double-left</v-icon>
            {{ $t("message.move_to_visitor") }}
          </v-btn>
          <v-btn small elevation="0" @click.stop="prospectToVisitorDialog = false; selectedProspectId = null">{{
            $t("message.close")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="archiveVisitorDialog" max-width="80%">
      <v-card class="pt-2">
        <v-card-title class="mt-4 text-subtitle-1">
          {{ $t('message.archive') }}
        </v-card-title>
        <v-card-text class="mt-4">
          {{ $t('message.are_you_sure') }}
        </v-card-text>
        <v-card-actions>
          <v-btn elevation="0" color="error" @click="archiveVisitor()">{{ $t('message.archive') }}</v-btn>
          <v-btn class="outlined-btn" elevation="0"
            @click.stop="archiveVisitorDialog = false; selectedVisitor = null">{{
              $t('message.close') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="sendEmailsDialog" max-width="90%">
      <v-card class="text-xs-left" outlined>
        <v-card-title>
          <span style="margin-right: 5px">{{ $t("message.send_email_to") }}:</span>
          <span>
            <b>{{ selectedItems ? selectedItems.length : 0 }}
              {{ $t("message.people") }}</b>
          </span>
        </v-card-title>
        <v-card-text>
          <v-select item-text="name" item-value="_id" outlined dense :clearable="true" v-model="selectedEmailTemplate"
            @change="selectEmailTemplate" :label="$t('message.select_email_template')" :items="emailTemplates">
          </v-select>
        </v-card-text>
        <v-card-text>
          <v-text-field outlined dense :label="$t('message.subject')" v-model="subject"></v-text-field>
        </v-card-text>
        <v-card-text>
          <div class="supporting-text" style="margin-left:5px">{{ $t("message.only_one_image") }}</div>
          <div style="overflow-y: auto">
            <VueEditor :style="'background-color:white;color:black'" v-model="editor" :editor-toolbar="editorToolbar" />
          </div>
          <div class="pt-0 pb-0 mb-0 mt-0">
            <div class="text-caption pa-0">{{ $t("message.email_tokens_explained") }}</div>
            <v-select outlined dense @change="copyToken" :label="$t('message.select_token_copy')"
              :items="availableTokens">
            </v-select>
          </div>
        </v-card-text>
        <v-card-text v-if="processingImages" class="p1-0 pr-0 text-center">
          <v-progress-linear :value="processingImagesProgress" :query="true" color="success" height="20"
            buffer-value="0" stream>
            <template v-slot:default="{ }">
              <span class="white--text">{{ $t("message.processing_images") }}</span>
            </template>
          </v-progress-linear>
        </v-card-text>
        <v-card-actions>
          <v-btn :loading="sendingEmails" outlined small elevation="0" color="primary" :disabled="sendingEmails"
            @click="sendEmailToUsers()">
            {{ $t("message.send") }}
          </v-btn>
          <v-btn class="outlined-btn" small elevation="0" @click="closeSendEmailDialog()">{{
            $t("message.cancel")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="inviteMemberDialog" max-width="80%">
      <v-card class="pa-2" outlined>
        <v-card-title>
          {{ $t("message.invite_members") }}
        </v-card-title>
        <v-card-text class="invite-link">
          <div class="mb-4">
            {{ $t("message.invite_member_link_explained") }}
          </div>
          <div class="truncate-text">
            <LinkIcon></LinkIcon> {{ inviteMemberLink }}
          </div>
        </v-card-text>
        <v-card-actions v-if="!isSmallerDisplay()">
          <v-btn :disabled="!inviteMemberLink" small elevation="0" color="primary" @click.stop="copyInviteMemberLink()">
            <v-icon>mdi-content-copy</v-icon>
            {{ $t("message.copy_link") }}
          </v-btn>
          <v-btn :disabled="!inviteMemberLink" small elevation="0" color="primary" @click.stop="openQRCode()">
            <v-icon>mdi-qrcode</v-icon>
            {{ $t("message.print_qr_code") }}
          </v-btn>
          <v-btn :disabled="!inviteMemberLink" small elevation="0" class="outlined-btn"
            @click.stop="inviteMemberDialog = false">{{
              $t("message.close")
            }}</v-btn>
        </v-card-actions>
        <div v-else>
          <v-btn block :disabled="!inviteMemberLink" small elevation="0" color="primary"
            @click.stop="copyInviteMemberLink()">
            <v-icon>mdi-content-copy</v-icon>
            {{ $t("message.copy_link") }}
          </v-btn>
          <v-btn class="mt-1" block :disabled="!inviteMemberLink" small elevation="0" color="primary"
            @click.stop="openInviteMemberQRCode()">
            <v-icon>mdi-qrcode</v-icon>
            {{ $t("message.print_qr_code") }}
          </v-btn>
          <v-btn block :disabled="!inviteMemberLink" small elevation="0" class="outlined-btn mt-1"
            @click.stop="inviteMemberDialog = false">{{
              $t("message.close")
            }}</v-btn>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="newUserDialog" max-width="90%">
      <div class="elevation-5" outlined>
        <v-card>
          <v-card-text>
            <h2 class="ml-4 mt-4">{{ $t('message.add_member') }}</h2>
            <div class="pl-4 pr-4 pt-2 pb-2">
              <v-form v-model="valid" ref="form" lazy-validation>
                <v-switch dense style="display:inline-block" :label="$t('message.is_minor')" v-model="newUser.isMinor">
                </v-switch>
                <v-text-field @keyup="checkExistingUser(newUser.email)" label="Email" v-model="newUser.email" required
                  outlined dense></v-text-field>
                <div>
                  <v-switch dense :label="$t('message.not_bjj_user')" v-model="newUser.notBjjUser"></v-switch>
                  <v-icon v-if="newUser.isMinor" :color="themeColor('primary')"
                    class="ml-2 mb-2">mdi-baby-face-outline</v-icon>
                  <v-icon v-else-if="newUser.notBjjUser" :color="themeColor('primary')"
                    class="ml-2 mb-2">mdi-account-remove-outline</v-icon>
                  <v-text-field :label="$t('message.first_name')" v-model="newUser.fName" autocomplete="false" required
                    outlined dense></v-text-field>
                  <v-text-field :label="$t('message.last_name')" v-model="newUser.lName" required outlined dense>
                  </v-text-field>
                  <GenderSelect :icon="false" v-model="newUser.gender"
                    v-show="!newUser.existing || !newUser.existing.gender" />
                  <v-text-field type="password" :label="$t('message.password')" v-model="newUser.password"
                    autocomplete="new-password" required outlined dense v-show="!newUser.existing"></v-text-field>
                  <BeltsSelect v-if="!newUser.notBjjUser" v-model="newUser.belt"
                    v-show="!newUser.existing || !newUser.existing.belt" />
                  <v-card-text class="mt-0 pl-0 pt-0">
                    <div class="text-subtitle-2">{{ $t('message.birthday') }}</div>
                    <date-picker :show-time="false" v-model="newUserDob" :past-event="true">
                    </date-picker>
                  </v-card-text>
                  <CountriesSelect v-model="newUser.nationality"
                    v-show="!newUser.existing || !newUser.existing.nationality" />
                  <v-switch :disabled="newUser.isMinor" :label="$t('message.old_enough')" v-model="newUser.ageMin">
                  </v-switch>
                </div>
                <div v-html="error" class="registration-error"></div>
              </v-form>
            </div>
          </v-card-text>
          <v-card-actions class="ml-6 mb-4">
            <v-btn small elevation="0" @click="register" color="primary" :disabled="!newUserReady()">
              <span v-show="!registring">
                {{ $t("message.add_member") }}
              </span>
              <v-progress-circular v-show="registring" indeterminate color="white"></v-progress-circular>
            </v-btn>
            <v-btn small elevation="0" @click="newUserDialog = false; newUser = {}" class="outlined-btn">
              <span>{{ $t("message.close") }}</span>
            </v-btn>
          </v-card-actions>
        </v-card>
      </div>
    </v-dialog>
    <v-dialog v-model="updateAttendanceAlertPercentDialog" max-width="90%">
      <v-card class="pa-2">
        <v-list two-line subheader>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>
                <v-text-field :label="$t('message.attendance_alerts_percent')" style="width:40%"
                  v-model="attendanceAlertPercent"></v-text-field>
              </v-list-item-title>
              <div class="supporting-text">
                {{ $t("message.attendance_alerts_percent_explained") }}
              </div>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-card-actions>
          <v-btn small elevation="0" @click="updateAttendanceAlertPercent()" color="primary">{{ $t('message.update')
          }}</v-btn>
          <v-btn small elevation="0" @click="updateAttendanceAlertPercentDialog = false">{{ $t('message.close')
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="uploadInquiriesDialog" max-width="90%">
      <v-card class="pa-2">
        <v-card-title>
          {{ $t('message.upload_inquiries') }}
        </v-card-title>
        <v-card-text>
          <v-btn block outlined small elevation="0" @click="downloadInquiriesTemplate()" color="primary">
            {{ $t('message.download_template') }}
          </v-btn>
          <div class="text-caption mb-2">
            {{ $t('message.template_explained') }}
          </div>

          <v-file-input class="mt-2" truncate-length="45" v-model="selectedFile" chips :label="$t('message.pick_file')"
            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            name="csv"></v-file-input>

          <div class="mt-2 text-center">
            <v-progress-linear v-if="uploadingFile" buffer-value="5" color="success" height="15" stream
              :value="uploadPercentage">
            </v-progress-linear>
          </div>
          <div v-if="uploadResults">
            <div class="text-subtitle-1">{{ $t('message.results') }}</div>
            <v-list>
              <v-list-group no-action>
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title class="success--text">{{ $t('message.successful') }} ({{
                      uploadResults.success.length
                    }})</v-list-item-title>
                  </v-list-item-content>
                </template>
                <v-list-item v-for="i in uploadResults.success" :key="'new_inquiry_' + i._id">
                  <v-list-item-content>
                    <v-list-item-title>{{ i.name }}</v-list-item-title>
                    <v-list-item-subtitle>{{ i.email }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list-group>
              <v-list-group no-action>
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title class="error--text">{{ $t('message.errors') }} ({{ uploadResults.error.length
                    }})</v-list-item-title>
                  </v-list-item-content>
                </template>
                <v-list-item v-for="i in uploadResults.error" :key="'new_inquiry_error_' + i.row">
                  <v-list-item-content>
                    <v-list-item-title>{{ i.email }}</v-list-item-title>
                    <v-list-item-subtitle>
                      <v-icon color="error">mdi-close-circle-outline</v-icon>
                      {{ $t('message.' + i.error_code) }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list-group>
            </v-list>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn :loading="uploadingFile" :disabled="!selectedFile" small elevation="0" @click="uploadInquiriesList()"
            color="primary">{{
              $t('message.upload')
            }}</v-btn>
          <v-btn :disabled="uploadingFile" small elevation="0" @click="uploadInquiriesDialog = false">{{
            $t('message.close') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="sendSMSDialog" max-width="90%">
      <v-card class="pa-2">
        <v-card-title>
          {{ $t('message.send_sms') }}
        </v-card-title>
        <v-card-text>
          {{ $t('message.coming_soon') }}
        </v-card-text>
        <v-card-actions>
          <v-btn outlined :disabled="true" small elevation="0" @click="sendSMS()" color="primary">{{ $t('message.send')
          }}</v-btn>
          <v-btn small elevation="0" @click="sendSMSDialog = false">{{ $t('message.close') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="tagsDialog" max-width="90%">
      <v-card v-if="availableTags" outlined>
        <v-card-title>
          <h3>{{ $t("message.member_labels") }}</h3>
        </v-card-title>
        <div class="mx-6">
          <tags-combo v-if="availableTags" v-model="selectedTags" :label="''" :items="availableTags"></tags-combo>
        </div>
        <div>
          <v-radio-group v-model="editTagsAction">
            <v-radio :label="$t('message.add')" :value="'add'"></v-radio>
            <v-radio :label="$t('message.remove')" :value="'remove'"></v-radio>
          </v-radio-group>
        </div>
        <v-card-actions>
          <v-btn outliend elevation="0" color="primary" @click="updateUserTags()">{{ $t("message.update") }}</v-btn>
          <v-btn elevation="0" class="outlined-btn" @click="closeTagsDialog()">{{
            $t("message.close")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="bulkEditCampaignDialog">
      <v-card outlined>
        <v-card-text class="text-h5">
          {{ $t('message.are_you_sure') }}
        </v-card-text>
        <v-card-actions>
          <v-btn elevation="0" color="primary" @click="toggleActiveForCampaign(true)">{{ $t('message.activate')
          }}</v-btn>
          <v-btn elevation="0" color="error" @click="toggleActiveForCampaign(false)">{{ $t('message.deactivate')
          }}</v-btn>
          <v-spacer></v-spacer>
          <v-btn elevation="0" @click="bulkEditCampaignDialog = false;">
            {{ $t('message.cancel') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="viewQRDialog">
      <v-card outlined v-if="currentQRCode">
        <v-card-title>
          {{ currentQRCode.title }}
        </v-card-title>
        <v-card-text class="text-center">
          <div style="display: inline-block;padding: 5px; border: 2px solid darkslategrey; border-radius: 5px;">
            <vue-qr v-if="currentQRCode.url" :text="currentQRCode.url" :size="300"></vue-qr>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn elevation="0" color="primary" outlined v-if="!isSmallerDisplay()" @click="openQrCodeNewPage()"><v-icon
              class="mr-1">mdi-open-in-new</v-icon>
            {{ $t('message.open_new_tab') }}
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn elevation="0" @click="viewQRDialog = false;">
            {{ $t('message.close') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="membershipDetailsDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card outlined>
        <v-toolbar dense flat class="opposite--text" color="primary">
          {{ $t("message.memberships") }} {{ $t("message.this_month").toLowerCase() }}
          <v-spacer></v-spacer>
          <v-btn icon small @click="membershipDetailsDialog = false;">
            <v-icon color="opposite">mdi-close-circle-outline</v-icon>
          </v-btn>
        </v-toolbar>
        <div>
          <v-skeleton-loader v-if="loadingMembershipDetails" type="article, list-item-avatar"></v-skeleton-loader>
          <div v-else-if="stats.memberships">
            <v-card-text class="text-center" v-if="!isSmallerDisplay()">
              <v-row>
                <v-col>
                  <v-icon style="margin-bottom:7px" size="25" color="success">mdi-plus</v-icon><span class="text-h6">
                    {{ stats.memberships.currency }}{{ roundNumber(stats.memberships.totalNew, 2) }}</span>
                </v-col>
                <v-col class="text-left">
                  <v-icon style="margin-bottom:7px" size="25" color="error">mdi-minus</v-icon><span class="text-h6">
                    {{ stats.memberships.currency }}{{ roundNumber(stats.memberships.totalCancelled, 2) }}</span>
                </v-col>
                <v-col class="text-left">
                  <v-icon size="25">mdi-equal</v-icon>
                </v-col>
                <v-col class="text-left">
                  <v-icon style="margin-bottom:7px" v-if="stats.memberships.totalCancelled > stats.memberships.totalNew"
                    size="50" color="error">mdi-minus</v-icon>
                  <v-icon style="margin-bottom:7px" v-else size="25" color="success">mdi-plus</v-icon>
                  <span class="text-h5">{{ stats.memberships.currency }}{{
                    Math.abs(roundNumber(stats.memberships.totalNew -
                      stats.memberships.totalCancelled, 2)) }}</span>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-text v-else>
              <div>
                <v-icon size="25" color="success">mdi-plus</v-icon><span class="text-h6">
                  {{ stats.memberships.currency }}{{ roundNumber(stats.memberships.totalNew, 2) }}</span>
              </div>
              <div>
                <v-icon size="25" color="error">mdi-minus</v-icon><span class="text-h6">
                  {{ stats.memberships.currency }}{{ roundNumber(stats.memberships.totalCancelled, 2) }}</span>
              </div>
              <v-divider></v-divider>
              <div>
                <v-icon v-if="stats.memberships.totalCancelled > stats.memberships.totalNew" size="50"
                  color="error">mdi-minus</v-icon>
                <v-icon v-else size="25" color="success">mdi-plus</v-icon>
                <span class="text-h6">{{ stats.memberships.currency }}{{
                  Math.abs(roundNumber(stats.memberships.totalNew -
                    stats.memberships.totalCancelled, 2)) }}</span>
              </div>
            </v-card-text>
            <v-list>
              <v-list-group :value="true">
                <template v-slot:activator>
                  <v-list-item-title>{{ $t("message.new") }} ({{ stats.memberships.new.length }})</v-list-item-title>
                </template>
                <div v-if="stats.memberships.new.length">
                  <v-list-item v-for="i in stats.memberships.new" :key="'new_membrship_details_' + i._id"
                    @click="goToTransaction(i._id)">
                    <v-list-item-avatar>
                      <MemberAvatar :image="i.userImage" size="35">
                      </MemberAvatar>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title><b>{{ i.currency }}{{ i.total }}</b> - {{ i.membership }}</v-list-item-title>
                      <v-list-item-subtitle>
                      </v-list-item-subtitle>{{ i.userName }}<v-list-item-subtitle>
                        {{ $d(new Date(i.date), "month_day_year", $i18n.locale) }} <span v-if="i.interval">({{
                          getIntervalDisplay(i.interval)
                        }})</span>
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </div>
                <v-card-text v-else>
                  {{ $t("message.no_data") }}
                </v-card-text>
              </v-list-group>
              <v-list-group :value="true">
                <template v-slot:activator>
                  <v-list-item-title>{{ $t("message.cancelled") }} ({{ stats.memberships.cancelled.length
                  }})</v-list-item-title>
                </template>
                <div v-if="stats.memberships.cancelled.length">
                  <v-list-item v-for="i in stats.memberships.cancelled" :key="'cancelled_membrship_details_' + i._id">
                    <v-list-item-avatar>
                      <MemberAvatar :image="i.userImage" size="35">
                      </MemberAvatar>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title><b>{{ i.currency }}{{ i.total }}</b> - {{ i.membership }}</v-list-item-title>
                      <v-list-item-subtitle>
                      </v-list-item-subtitle>{{ i.userName }}<v-list-item-subtitle>
                        {{ $d(new Date(i.date), "month_day_year", $i18n.locale) }} <span v-if="i.interval">({{
                          getIntervalDisplay(i.interval)
                        }})</span>
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </div>
                <v-card-text v-else>
                  {{ $t("message.no_data") }}
                </v-card-text>
              </v-list-group>
            </v-list>
          </div>
          <v-card-text v-else>
            {{ $t("message.no_data") }}
          </v-card-text>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import GraphLoader from "@/components/displays/GraphLoader.vue";
import MemberAvatar from "@/components/displays/MemberAvatar.vue";
import BeltsSelect from "@/components/inputs/BeltsSelect.vue";
import CountriesSelect from "@/components/inputs/CountriesSelect.vue";
import DatePicker from "@/components/inputs/DateTimePicker.vue";
import GenderSelect from "@/components/inputs/GenderSelect.vue";
import TagsCombo from "@/components/inputs/TagsCombo.vue";
import Api from "@/services/Api2";
import { Environment } from "@/services/Environment";
import ApexChart from 'vue-apexcharts';
import VueQr from 'vue-qrcode-component';
import { VueEditor } from "vue2-editor";

export default {
  data() {
    return {
      urlTab: this.$route.params.tabId,
      activeTab: 0,
      atRiskTotal: 0,
      atRisk: [],
      leads: [],
      visitors: [],
      inquiries: [],
      archivedInquiries: [],
      archivedInquiry: null,
      tagsDialog: null,
      selectedTags: null,
      filteredVisitors: [],
      filteredInquiries: [],
      filteredAtRisk: [],
      filteredLeads: [],
      processingImagesProgress: 20,
      processingImages: false,
      displayPMPLinks: false,
      tagVisitorFilter: null,
      prospectToVisitorDialog: null,
      newProspectDialog: false,
      nameVisitorFilter: null,
      nameInquiryFilter: null,
      bulkEditCampaignDialog: null,
      selectedCampaign: null,
      nameAffiliateFilter: null,
      nameAtRiskFilter: null,
      nameLeadFilter: null,
      selectedVisitor: null,
      newUserDialog: null,
      newUser: {},
      registring: false,
      attendanceAlertPercent: 25,
      updateAttendanceAlertPercentDialog: null,
      error: null,
      valid: true,
      currentQRCode: null,
      viewQRDialog: null,
      archiveVisitorDialog: null,
      availableTags: null,
      loadingHome: true,
      currencySymbol: '$',
      newProspect: {},
      editTagsAction: 'add',
      selectedItems: [],
      emailTemplates: [],
      affiliates: [],
      filteredAffiliates: [],
      campaigns: [],
      newVisitDate: new Date(),
      newUserDob: null,
      selectedProspectId: null,
      editor: null,
      editorToolbar: this.getEditorToolbar(),
      subject: null,
      selectedEmailTemplate: null,
      sendingEmails: false,
      inviteMemberDialog: null,
      loadingMembershipDetails: false,
      inviteMemberLink: null,
      sendEmailsDialog: null,
      sendSMSDialog: null,
      currentMonth: null,
      atRiskDays: 14,
      uploadingFile: false,
      membershipDetailsDialog: null,
      uploadingPercentage: 0,
      uploadInquiriesDialog: false,
      uploadPercentage: 10,
      addingInquiry: false,
      uploadResults: null,
      selectedFile: null,
      growthTrendine: { data: [], options: null },
      attendanceTrendine: { data: [], options: null },
      stats: { conversionSpline: {}, avgConvertion: 0, upcomingVisits: [], newMemberships: 0, cancelledMemberships: 0, totalMemberships: 0, trialing: 0, inquiries: 0, attendance: { delta: 0, total: 0 }, retentionRate: { value: 0, color: 'error' } },
      availableTokens: this.getAvailableTokens(),
      loadingAtRisk: false,
      loadingList: false,
      academyName: null,
      iTagsFilter: null,
      vTagsFilter: null,
      lTagsFilter: null,
      headersVisitors: [
        {
          text: "",
          align: "left",
          sortable: false,
          value: "checkbox",
        },
        { text: this.$t("message.name"), value: "name" },
        { text: this.$t("message.email"), value: "email" },
        { text: this.$t("message.phone"), value: "phone" },
        { text: this.$t("message.visit_date"), value: "firstVisit" },
        { text: this.$t("message.source"), value: "source" },
        { text: this.$t("message.actions"), value: "_id" },
      ],
      headersAtRisk: [
        {
          text: "",
          align: "left",
          sortable: false,
          value: "checkbox",
        },
        { text: this.$t("message.name"), value: "name" },
        { text: this.$t("message.email"), value: "email" },
        { text: this.$t("message.last_checkin"), value: "checkin" },
        { text: this.$t("message.days"), value: "days" },
        { text: this.$t("message.class"), value: "className" },
        { text: this.$t("message.actions"), value: "_id" },
      ],
      headersAffiliates: [
        {
          text: "",
          align: "left",
          sortable: false,
          value: "checkbox",
        },
        { text: this.$t("message.name"), value: "name" },
        { text: this.$t("message.email"), value: "email" },
        { text: this.$t("message.since"), value: "createdAt" },
        { text: this.$t("message.campaign"), value: "campaign" },
        { text: this.$t("message.referrals"), value: "referrals" },
        { text: this.$t("message.paid"), value: "totalPaid" },
        { text: this.$t("message.interactions"), value: "interactions" },
        { text: this.$t("message.active"), value: "active" },
      ],
      headersInquiries: [
        {
          text: "",
          align: "left",
          sortable: false,
          value: "checkbox",
        },
        { text: this.$t("message.name"), value: "name" },
        { text: this.$t("message.email"), value: "email" },
        { text: this.$t("message.phone"), value: "phone" },
        { text: this.$t("message.created"), value: "created" },
        { text: this.$t("message.actions"), value: "_id" },
      ],
      campaignData: null,
    };
  },
  components: {
    VueEditor,
    DatePicker,
    TagsCombo,
    CountriesSelect,
    BeltsSelect,
    GraphLoader,
    GenderSelect,
    MemberAvatar,
    VueQr,
    ApexChart
  },
  mounted() {
    if (this.urlTab) {
      try {
        const n = new Number(this.urlTab);
        this.activeTab = n.valueOf();
      } catch (err) {
        console.log('Invalid tab: ', this.urlTab)
      }
    }
  },
  created() {
    Api()
      .get("admins/academy/" + this.$store.state.selectedAcademy)
      .then((response) => {
        this.displayPMPLinks = response.data.paymentsModule == 'stripe' || response.data.stripeAccountId ? true : false;
        this.attendanceAlertPercent = response.data.attendanceDeltaAlert;
        this.academyName = response.data.name;
        this.currencySymbol = response.data.currencySymbol;
        if (response.data.city && response.data.city.country)
          this.newProspect = { nationality: response.data.city.country }
      });
    this.getVisitors();
    this.getInquiries(true);
    this.getLeads();
    this.getAtRisk();
    this.getAvailableTags();
    this.getGrowthData();
    if (this.urlTab == 5)
      this.getAffiliates();
  },
  watch: {
    '$route'(to) {
      this.activeTab = to.params.tabId;
    },
    nameVisitorFilter: {
      handler: function (newValue) {
        this.filterTableByNameOrEmail(newValue, 'visitors');
      },
    },
    nameInquiryFilter: {
      handler: function (newValue) {
        this.filterTableByNameOrEmail(newValue, 'inquiries');
      },
    },
    nameAffiliateFilter: {
      handler: function (newValue) {
        this.filterTableByNameOrEmail(newValue, 'affiliates');
      },
    },
    nameLeadFilter: {
      handler: function (newValue) {
        this.filterTableByNameOrEmail(newValue, 'leads');
      },
    },
    nameAtRiskFilter: {
      handler: function (newValue) {
        this.filterTableByNameOrEmail(newValue, 'atRisk');
      },
    }
  },
  methods: {
    getMembershipDetails() {
      this.loadingMembershipDetails = true;
      const from = this.toBeginningOfMonth();
      Api()
        .get(
          "admins/managedacademy/" +
          this.$store.state.managedAcademy +
          "/growth/memberships?from=" + from
        ).then((response) => {
          if (response.data) {
            this.stats.memberships = response.data.data;
            if (this.stats.memberships) {
              this.stats.cancelledMemberships = this.stats.memberships.cancelled ? this.stats.memberships.cancelled.length : 0;
              this.stats.newMemberships = this.stats.memberships.new ? this.stats.memberships.new.length : 0;
              this.stats.totalMemberships = this.stats.newMemberships - this.stats.cancelledMemberships;
            }
            this.loadingMembershipDetails = false;
          }
        })
    },
    homeFinishedLoading() {
      if (this.stats.upcomingVisits && this.stats.attendance)
        return true;
      return false;
    },
    getCampaignDetails() {
      Api()
        .post("referrals/managedacademy/" + this.$store.state.managedAcademy + "/affiliates/campaign/details", { campaign: this.selectedCampaign })
        .then((response) => {
          let data = response.data.trendline;
          let campaignData = {
            referrals: {
              data: [response.data.referralsConverted, response.data.referralsPending],
              options: {
                legend: {
                  show: false
                },
                stroke: { show: false },
                theme: {
                  mode: this.isDarkMode() ? 'dark' : 'light',
                },
                chart: { background: 'none' },
                plotOptions: {
                  pie: {
                    dataLabels: {
                      offset: -10
                    }
                  }
                },
                colors: [this.themeColor('success'), this.themeColor('error')],
                labels: [this.$t("message.converted"), this.$t("message.pending")]
              }
            },
            trendline: {},
            referralsConverted: response.data.referralsConverted,
            referralsPending: response.data.referralsPending,
            referralsTotal: response.data.referralsTotal,
            tops: response.data.topAffiliates && response.data.topAffiliates.length ? response.data.topAffiliates : null
          };
          campaignData.trendline.data = [
            {
              name: data.seriesLabels[0],
              data: data.seriesData[0]
            },
            {
              name: data.seriesLabels[1],
              data: data.seriesData[1]
            },
          ];
          //Set up the dates:
          const categories = [];
          for (const i of data.dates) {
            const d = new Date();
            d.setDate(i.day);
            d.setMonth(i.month);
            d.setFullYear(i.year);
            d.setHours(0);
            d.setMinutes(0);
            categories.push(d)
          }
          campaignData.trendline.options = {
            colors: [this.themeColor('primary'), this.themeColor('orange')],
            xaxis: {
              categories: categories,
              labels: {
                show: false,
              }
            },
            yaxis: {
              labels: {
                show: false,
              }
            },
            tooltip: {
              x: {
                format: 'dd/MM/yy'
              },
            },
            dataLabels: {
              enabled: false,
            },
            stroke: {
              curve: 'smooth'
            },
            theme: {
              mode: this.isDarkMode() ? 'dark' : 'light',
            },
            chart: {
              toolbar: {
                show: false
              },
              background: 'none'
            },
            legend: {
              position: 'bottom'
            },
            grid: {
              borderColor: this.themeColor('gray'),
              yaxis: {
                lines: {
                  show: false  //or just here to disable only x axis grids
                }
              },
            },
          };
          this.campaignData = campaignData;
        }).catch((e) => {
          console.log(e)
          this.showAlert('error', this.$t('message.oops_not_working'));
        });
    },
    confirmBulkCampiagnUpdate(campaign) {
      this.selectedCampaign = campaign;
      this.bulkEditCampaignDialog = true;
    },
    toggleActiveForCampaign(activate) {
      const campaign = this.selectedCampaign;
      Api()
        .patch("referrals/managedacademy/" + this.$store.state.managedAcademy + "/affiliates/campaign/active/toggle", { campaign: campaign, active: activate })
        .then(() => {
          this.getAffiliates();
          this.bulkEditCampaignDialog = false;
        }).catch((e) => {
          console.log(e)
          this.showAlert('error', this.$t('message.oops_not_working'));
        });
    },
    updateUserTags() {
      let recipients = [];
      if (this.selectedItems) {
        for (const r of this.selectedItems) {
          recipients.push(r._id);
        }
      }
      if (recipients.length > 0 && this.selectedTags && this.selectedTags.length > 0) {
        const data = {
          dataIds: recipients,
          action: this.editTagsAction,
          tags: this.selectedTags
        };
        Api()
          .patch(
            "admins/academy/" +
            this.$store.state.managedAcademy +
            "/members/tags",
            data
          )
          .then((response) => {
            const data = response.data;
            if (data) {
              this.selectedTags = null;
              this.getAvailableTags();
              this.closeTagsDialog();
              this.showAlert(
                "success",
                this.$t("message.success")
              );
            }
          })
          .catch((e) => {
            this.loading = false;
            if (e)
              this.showAlert("error", this.$t("message.error_generic"));
          });
      }
    },
    closeTagsDialog() {
      this.tagsDialog = false;
      this.selectedMember = null;
    },
    async uploadInquiriesList() {
      this.uploadingFile = true;
      this.uploadResults = null;
      const vm = this;
      let formData = new FormData();
      formData.append("file", this.selectedFile);
      try {
        const results = await Api().post("admins/managedacademy/" +
          this.$store.state.managedAcademy +
          "/inquiries/upload", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: function (progressEvent) {
            const percent = parseInt(Math.round((progressEvent.loaded / progressEvent.total) * 100));
            if (percent >= 97)
              vm.uploadPercentage = 97;//Stay on 97
            else
              vm.uploadPercentage = percent;
          },
        });
        this.uploadingFile = false;
        this.selectedFile = null;
        if (results && results.data) {
          this.uploadResults = {
            success: results.data.newInquiries,
            error: results.data.errors
          };
        }
      } catch (err) {
        this.showAlert("error", "Error :(");
        this.uploadingFile = false;
        this.selectedFile = null;
      }
    },
    openQrCodeNewPage() {
      //window.open(process.env.VUE_APP_ASSETS_HOME + 'secure/qr/' + encodedUrl + '?sp=waiver');
      let buff = new Buffer(this.currentQRCode.url);
      const encodedUrl = buff.toString("base64");
      if (this.currentQRCode.type == 'waiver')
        window.open(Environment.get("VUE_APP_ASSETS_HOME") + 'secure/qr/' + encodedUrl + '?sp=waiver');
      else if (this.currentQRCode.type == 'invite')
        window.open(Environment.get("VUE_APP_ASSETS_HOME") + 'secure/qr/' + encodedUrl + '?sp=invite');
      else if (this.currentQRCode.type == 'new_visit')
        window.open(Environment.get("VUE_APP_ASSETS_HOME") + 'secure/qr/' + encodedUrl + '?sp=new_visit');
      else if (this.currentQRCode.type == 'schedule')
        window.open(Environment.get("VUE_APP_ASSETS_HOME") + 'secure/qr/' + encodedUrl + '?sp=schedule');
      else if (this.currentQRCode.type == 'memberships')
        window.open(Environment.get("VUE_APP_ASSETS_HOME") + 'secure/qr/' + encodedUrl + '?sp=memberships');
      else if (this.currentQRCode.type == 'contact')
        window.open(Environment.get("VUE_APP_ASSETS_HOME") + 'secure/qr/' + encodedUrl + '?sp=contact');
    },
    downloadInquiriesTemplate() {
      window.open(this.assets("templates/BJJLINK_UploadInquiries_Template.csv"));
    },
    showUploadDialog() {
      this.uploadInquiriesDialog = true;
    },
    openVisitorWaiverQrCode(link) {
      const baseUrl = Environment.get("VUE_APP_API_HOST");
      const urlToCopy = baseUrl + '/pub/academy/' + this.$store.state.selectedAcademy + '/waiver';
      if (!link) {
        this.currentQRCode = { title: this.$t("message.visitor_waiver"), url: urlToCopy, type: 'waiver' };
        this.viewQRDialog = true;
      } else {
        this.copyToClipboard(urlToCopy);
      }
    },
    openInviteMemberQRCode(link) {
      const urlToCopy = 'https://connect.bjjlink.com/register?i=' + btoa(this.$store.state.user._id) + '&a=' +
        btoa(this.$store.state.selectedAcademy) +
        '&an=' + btoa(this.academyName.replace(/[^a-zA-Z ]/g, ""));
      if (!link) {
        this.currentQRCode = { title: this.$t("message.invite_members"), url: urlToCopy, type: 'invite' };
        this.viewQRDialog = true;
      } else {
        this.copyToClipboard(urlToCopy);
      }
    },
    closeSendEmailDialog() {
      this.sendEmailsDialog = false;
      this.sendingEmails = false;
    },
    getGrowthData() {
      let from = new Date();
      this.currentMonth = this.$d(from, "month_year", this.$i18n.locale);
      from.setMonth(from.getMonth() - 12);
      from.setDate(1);
      from.setHours(0);
      from.setMinutes(0);
      let from2 = new Date(from);
      const to = new Date();
      const months = [];
      const months2 = [];
      let d1 = new Date(from);
      for (let d = d1; d <= to; d1.setMonth(d1.getMonth() + 1)) {
        months.push({ key: d.getFullYear() + '-' + (d.getMonth() + 1), date: new Date(d) });
        months2.push({ key: d.getFullYear() + '-' + (d.getMonth() + 1), date: new Date(d) });
      }
      this.upcomingVisits();
      this.getGrowthTrendline(from.toISOString(), months);
      this.getMembershipDetails();
      this.getTrialing();
      this.getAttendanceStats(from2.toISOString(), months2);
    },
    getAttendanceStats(last12, months) {
      const from = new Date();
      from.setHours(0);
      from.setMinutes(0);
      from.setDate(from.getDate() - 30);
      Api()
        .get(
          "admins/academy/" +
          this.$store.state.managedAcademy +
          "/growth/attendance?from=" + from.toISOString(0) + "&from2=" + last12
        ).then((response) => {
          if (response.data) {
            this.stats.attendance = response.data.attendance;

            const visitorsData = this.stats.attendance.visitorCheckins;
            const membersData = this.stats.attendance.memberCheckins;
            let visitors = [];
            let members = [];
            let categories = [];
            for (const month of months) {
              const monthString = this.$d(new Date(month.date), "month_year", this.$i18n.locale);
              categories.push(monthString);
              let found = false;
              if (membersData && membersData.length > 0) {
                for (const d of membersData) {
                  if (d.key == month.key) {
                    members.push(d.count);
                    found = true;
                    break;
                  }
                }
              }
              if (!found)
                members.push(0);
              found = false;
              if (visitorsData && visitorsData.length > 0) {
                for (const d of visitorsData) {
                  if (d.key == month.key) {
                    visitors.push(d.count);
                    found = true;
                    break;
                  }
                }
              }
              if (!found)
                visitors.push(0);
            }

            const series = [
              {
                name: this.$t("message.member_attendance"),
                data: members
              },
              {
                name: this.$t("message.visitor_attendance"),
                data: visitors
              },
            ];
            this.attendanceTrendine.data = series;
            this.attendanceTrendine.options = {
              labels: [this.$t("message.member_attendance"), this.$t("message.visitor_attendance")],
              colors: [this.themeColor('graph1'), this.themeColor('graph2')],
              xaxis: {
                categories: categories,
                labels: {
                  show: true,
                }
              },
              yaxis: {
                labels: {
                  show: true,
                }
              },
              dataLabels: {
                enabled: false,
              },
              stroke: {
                curve: 'smooth'
              },
              theme: {
                mode: this.isDarkMode() ? 'dark' : 'light',
              },
              chart: {
                toolbar: {
                  show: false
                },
                background: 'none'
              },
              legend: {
                position: 'top'
              },
              grid: {
                show: false
              },
            };
            if (this.homeFinishedLoading())
              this.loadingHome = false;
          }
        })
    },
    upcomingVisits() {
      const from = new Date().toISOString();
      Api()
        .get(
          "admins/academy/" +
          this.$store.state.managedAcademy +
          "/growth/upcoming-visits?from=" + from
        ).then((response) => {
          if (response.data) {
            this.stats.upcomingVisits = response.data.upcomingVisits;
            if (this.homeFinishedLoading())
              this.loadingHome = false;
          }
        })
    },
    getTrialing() {
      const from = new Date().toISOString();
      Api()
        .get(
          "admins/academy/" +
          this.$store.state.managedAcademy +
          "/growth/trialing?from=" + from
        ).then((response) => {
          if (response.data) {
            this.stats.trialing = response.data.trialing;
            if (this.homeFinishedLoading())
              this.loadingHome = false;
          }
        })
    },
    getGrowthTrendline(from, months) {
      Api()
        .get(
          "admins/academy/" +
          this.$store.state.managedAcademy +
          "/growth/trendline?from=" + from
        ).then((response) => {
          if (response.data) {
            const data = response.data.data;
            let memberships = [];
            let visitors = [];
            let inquiries = [];
            let retentions = [];
            let categories = [];
            let conversions = [];
            let convertedVisits = [];
            let nonConvertedVisits = [];
            let cancelled = [];
            let latestRetention = 0;
            for (const month of months) {
              const monthString = this.$d(new Date(month.date), "month_year", this.$i18n.locale);
              categories.push(monthString);
              let found = false;
              if (data.memberships && data.memberships.length > 0) {
                for (const d of data.memberships) {
                  if (d.key == month.key) {
                    memberships.push(d.count);
                    found = true;
                    break;
                  }
                }
              }
              if (!found)
                memberships.push(0);
              found = false;
              if (data.visitors && data.visitors.length > 0) {
                for (const d of data.visitors) {
                  if (d.key == month.key) {
                    visitors.push(d.count);
                    found = true;
                    break;
                  }
                }
              }
              if (!found)
                visitors.push(0);

              found = false;
              if (data.cancelled && data.cancelled.length > 0) {
                for (const d of data.cancelled) {
                  if (d.key == month.key) {
                    cancelled.push(d.count);
                    found = true;
                    break;
                  }
                }
              }
              if (!found)
                cancelled.push(0);

              found = false;
              if (data.inquiries && data.inquiries.length > 0) {
                for (const d of data.inquiries) {
                  if (d.key == month.key) {
                    inquiries.push(d.count);
                    found = true;
                    break;
                  }
                }
              }
              if (!found)
                inquiries.push(0);

              //Conversion Rates
              found = false;
              if (data.retention && data.retention.length > 0) {
                for (const d of data.retention) {
                  if (d.key == month.key) {
                    retentions.push(d.rate);
                    found = true;
                    latestRetention = d.rate;
                    break;
                  }
                }
              }
              if (!found)
                retentions.push(0);

              //get retention for this month

              //Converted
              found = false;
              if (data.convertedVisits && data.convertedVisits.length > 0) {
                for (const d of data.convertedVisits) {
                  if (d.key == month.key) {
                    convertedVisits.push(d.count);
                    found = true;
                    break;
                  }
                }
              }
              if (!found)
                convertedVisits.push(0);

              //Not converted
              found = false;
              if (data.nonConvertedVisits && data.nonConvertedVisits.length > 0) {
                for (const d of data.nonConvertedVisits) {
                  if (d.key == month.key) {
                    nonConvertedVisits.push(d.count);
                    found = true;
                    break;
                  }
                }
              }
              if (!found)
                nonConvertedVisits.push(0);
            }

            const retentionRateColor = (latestRetention < 70 ? this.themeColor('error') : (latestRetention < 85 ? this.themeColor('yellow') : this.themeColor('success')));
            const retentionRateColorTheme = (latestRetention < 70 ? 'error' : (latestRetention < 85 ? 'yellow' : 'success'));
            this.stats.retentionRate.value = latestRetention;
            this.stats.retentionRate.color = retentionRateColor;
            this.stats.retentionRate.colorTheme = retentionRateColorTheme;

            //Now we find the conversaion rate
            let i = 0;
            for (const converted of convertedVisits) {
              const nonConverted = nonConvertedVisits[i];
              if (nonConverted > 0) {
                const totalVisitors = converted + nonConverted;
                if (nonConverted == converted)
                  conversions.push(100);
                else
                  conversions.push(Math.round(converted / totalVisitors * 100))
              }
            }
            //Fix me
            this.stats.avgConvertion = Math.round(conversions.reduce((a, b) => a + b, 0) / conversions.length);
            this.stats.conversionSpline.data = [
              {
                name: this.$t("message.conversion_rate"),
                data: conversions
              }
            ];
            this.stats.conversionSpline.options = {
              labels: { show: false },
              colors: [this.themeColor('graph1')],
              xaxis: {
                categories: categories,
                show: false,
                labels: {
                  show: false
                },
                axisBorder: {
                  show: false
                },
                axisTicks: {
                  show: false
                },
                tooltip: {
                  enabled: false
                }
              },
              yaxis: {
                labels: {
                  show: false,
                }
              },
              dataLabels: {
                enabled: false,
              },
              stroke: {
                curve: 'smooth',
                width: 3
              },
              theme: {
                mode: this.isDarkMode() ? 'dark' : 'light',
              },
              chart: {
                toolbar: {
                  show: false
                },
                background: 'none'
              },
              legend: {
                show: false
              },
              grid: {
                show: false
              },
            };

            if (inquiries.length)
              this.stats.inquiries = inquiries[inquiries.length - 1];
            const series = [
              {
                name: this.$t("message.new_memberships"),
                data: memberships
              },
              {
                name: this.$t("message.new_visits"),
                data: visitors
              },
              {
                name: this.$t("message.canceled_memberships"),
                data: cancelled
              },
              {
                name: this.$t("message.inquiries"),
                data: inquiries
              },
              {
                name: this.$t("message.retention_rate"),
                data: retentions
              },
            ];
            this.growthTrendine.data = series;
            this.growthTrendine.options = {
              labels: [
                this.$t("message.new_memberships"),
                this.$t("message.new_visits"),
                this.$t("message.canceled_memberships"),
                this.$t("message.inquiries"),
                this.$t("message.retention_rate")
              ],
              colors: [
                this.themeColor('graph1'),
                this.themeColor('purple'),
                this.themeColor('graph3'),
                this.themeColor('secondary'),
                retentionRateColor
              ],
              xaxis: {
                categories: categories,
              },
              // 1. FILL: Opacity 0 for the 5th series (Retention) removes its area
              fill: {
                type: ['gradient', 'gradient', 'gradient', 'gradient', 'solid'],
                opacity: [0.35, 0.35, 0.35, 0.35, 0],
                gradient: {
                  shadeIntensity: 1,
                  opacityFrom: 0.45,
                  opacityTo: 0.05,
                  stops: [20, 100]
                }
              },
              // 2. MARKERS: Only show for the 5th series (Retention)
              markers: {
                size: [0, 0, 0, 0, 5],
                strokeColors: '#fff',
                strokeWidth: 2,
                hover: {
                  size: 7,
                }
              },
              // 3. STROKE: First four are smooth, Retention (5th) is straight
              stroke: {
                curve: ['smooth', 'smooth', 'smooth', 'smooth', 'straight'],
                width: [3, 3, 3, 3, 4]
              },
              yaxis: [
                {
                  seriesName: this.$t("message.new_memberships"),
                  title: { text: "" },
                  labels: { show: true }
                },
                { seriesName: this.$t("message.new_memberships"), show: false },
                { seriesName: this.$t("message.new_memberships"), show: false },
                { seriesName: this.$t("message.new_memberships"), show: false },
                {
                  opposite: true,
                  seriesName: this.$t("message.retention_rate"),
                  min: 0,
                  max: 100,
                  title: { text: this.$t("message.retention_rate") + " %" },
                  labels: {
                    show: true,
                    formatter: (val) => val.toFixed(0) + '%'
                  }
                }
              ],
              chart: {
                type: 'area',
                toolbar: { show: false },
                background: 'none'
              },
              dataLabels: { enabled: false },
              theme: {
                mode: this.isDarkMode() ? 'dark' : 'light',
              },
              legend: { position: 'top' },
              grid: { show: false },
              tooltip: {
                shared: true,
                y: {
                  formatter: function (y, { seriesIndex }) {
                    if (typeof y !== "undefined") {
                      return seriesIndex === 4 ? y.toFixed(0) + "%" : y.toFixed(0);
                    }
                    return y;
                  }
                }
              }
            };
            if (this.homeFinishedLoading())
              this.loadingHome = false;
          }
        })
    },
    sendSMS() {
      let recipients = [];
      let postData = {};
      if (this.selectedItems) {
        for (const r of this.selectedItems) {
          if (r._id) recipients.push(r._id);
        }
      }
      postData.recipients = recipients;
      console.log(recipients);
    },
    openSendSMSDialog() {
      if (this.selectedItems && this.selectedItems.length > 0)
        this.sendSMSDialog = true;
      else
        this.showAlert("info", this.$t("message.at_least_one_member"));
    },
    updateAttendanceAlertPercent() {
      Api()
        .patch(
          "admins/academy/" +
          this.$store.state.managedAcademy +
          "/attendanceDeltaAlert",
          { attendanceDeltaAlert: this.attendanceAlertPercent }
        )
        .then((response) => {
          if (response) this.showAlert("success", this.$t("message.updated"));
          this.updateAttendanceAlertPercentDialog = false;
          this.getAtRisk();
        });
    },
    register() {
      try {
        if (this.newUserDob) {
          let d = new Date(this.newUserDob);
          d.setHours(0);
          d.setMinutes(0);
          this.newUser.dob = d;
        }
        this.registring = true;
        if (this.newUser.password) {
          let buff = new Buffer(this.newUser.password);
          let base64data = buff.toString("base64");
          this.newUser.password = base64data;
        }
        this.newUser.academy = this.$store.state.selectedAcademy;
        if (this.newUser.notBjjUser) this.newUser.belt = "white";
        this.newUser.existing = null;
        Api()
          .post(
            "admins/academy/" + this.$store.state.managedAcademy + "/new_member",
            this.newUser
          )
          .then((response) => {
            try {
              if (response.data) {
                this.newUserDialog = false;
                this.registring = false;
                //this.newUser = {};
                const newUser = response.data;
                this.loading = false;
                //Load members again and approve this new member
                if (newUser.isMinor) {
                  this.approveMember(newUser, false);
                } else {
                  this.approveMember(newUser, false);
                }
              }
            } catch (e) {
              console.log(e);
            }
          })
          .catch((e) => {
            this.registring = false;
            if (e.response.status == 409) {
              this.showAlert(
                "error",
                this.$t("message.already_a_user"),
                9000
              );
            } else {
              this.showAlert("error", "Oops!", "Error :(");
            }
          });
      } catch (err) {
        console.log(err)
      }

    },
    approveMember(member, reapprove) {
      var data = { members: [member._id] };
      if (reapprove) data["rejected"] = true;
      Api()
        .post(
          "admins/academy/" + this.$store.state.selectedAcademy + "/approve",
          data
        )
        .then((response) => {
          const data = response.data;
          if (data) {
            this.newUser = {};
            this.getVisitors();
            this.getInquiries();
            this.getLeads();
          }
        })
        .catch((e) => {
          if (e)
            this.showAlert("error", "Oops!", this.$t("message.error_generic"));
        });
    },
    getAtRisk() {
      this.loadingAtRisk = true;
      Api()
        .get("admins/academy/" + this.$store.state.managedAcademy + "/at-risk?days=" + this.atRiskDays)
        .then((response) => {
          if (response.data && response.data.list) {
            this.atRisk = response.data.list;
            this.filteredAtRisk = this.atRisk;
            this.loadingAtRisk = false;
            this.atRiskTotal = response.data.list.length;
          }
        });
    },
    removeAtRisk(member) {
      Api()
        .patch("admins/academy/" + this.$store.state.managedAcademy + "/remove/at-risk/member/" + member.id)
        .then(() => {
          this.getAtRisk();
          this.showAlert("success", this.$t("message.updated"));
        });
    },
    addLead(item) {
      Api()
        .post("admins/academy/" + this.$store.state.managedAcademy + "/leads/add", { dataId: item._id })
        .then((response) => {
          if (response.data) {
            this.getInquiries();
            this.getVisitors();
            this.getLeads();
          }
        }).catch(() => {
          this.showAlert("error", "Oops!", this.$t("message.error_generic"));
        });
    },
    removeLead(item) {
      Api()
        .patch("admins/academy/" + this.$store.state.managedAcademy + "/leads/remove", { dataId: item._id })
        .then((response) => {
          if (response.data) {
            this.getInquiries();
            this.getVisitors();
            this.getLeads();
          }
        }).catch(() => {
          this.showAlert("error", "Oops!", this.$t("message.error_generic"));
        });
    },
    filterTableByNameOrEmail(value, table) {
      let list = this.visitors;
      let filteredList = this.filteredVisitors;
      if (table == 'inquiries') {
        list = this.inquiries;
        filteredList = this.filteredInquiries;
      } else if (table == 'affiliates') {
        list = this.affiliates;
        filteredList = this.filteredAffiliates;
      } else if (table == 'leads') {
        list = this.leads;
        filteredList = this.filteredLeads;
      } else if (table == 'atRisk') {
        list = this.atRisk;
        filteredList = this.filteredAtRisk;
      }
      if (!value || value == "") {
        filteredList = list;
      } else {
        value = value.toLowerCase();
        if (list) {
          let filtered = [];
          for (const m of list) {
            const name = m.name ? m.name : "";
            const email = m.email ? m.email : "";
            //Also search campaign if affiliates
            if (table == 'affiliates') {
              const campaign = m.campaign ? m.campaign : "";
              if (
                name.toLowerCase().indexOf(value) >= 0 ||
                email.toLowerCase().indexOf(value) >= 0 ||
                campaign.toLowerCase().indexOf(value) >= 0
              ) {
                filtered.push(m);
              }
            } else if (
              name.toLowerCase().indexOf(value) >= 0 ||
              email.toLowerCase().indexOf(value) >= 0
            ) {
              filtered.push(m);
            }
          }
          filteredList = filtered;
        }
      }

      if (table == 'inquiries') {
        this.filteredInquiries = filteredList;
      } else if (table == 'leads') {
        this.filteredLeads = filteredList;
      } else if (table == 'affiliates') {
        this.filteredAffiliates = filteredList;
      } else if (table == 'atRisk') {
        this.filteredAtRisk = filteredList;
      } else {
        this.filteredVisitors = filteredList;
      }
    },
    copyToken(val) {
      this.copyToClipboard(val);
    },
    newUserReady() {
      if (
        this.newUser.fName &&
        this.newUser.lName &&
        this.newUser.email &&
        (this.newUser.password || this.newUser.existing) &&
        this.newUser.nationality &&
        (this.newUser.notBjjUser || this.newUser.belt) &&
        (this.newUser.ageMin || this.newUser.isMinor)
      ) {
        return true;
      }
      return false;
    },
    copyPublicContactForm() {
      let urlToCopy = 'https://api.bjjlink.com/pub/academy/' + this.$store.state.selectedAcademy + '/contact/form'
      this.copyToClipboard(urlToCopy);
    },
    openPublicContactQr(link) {
      const baseUrl = Environment.get("VUE_APP_API_HOST");
      const urlToCopy = baseUrl + '/pub/academy/' + this.$store.state.selectedAcademy + '/contact/form';
      if (!link) {
        this.currentQRCode = { title: this.$t("message.contact_form"), url: urlToCopy, type: 'contact' };
        this.viewQRDialog = true;
      } else {
        this.copyToClipboard(urlToCopy)
      }
    },
    openScheduleVisitorQr(link) {
      const baseUrl = Environment.get("VUE_APP_API_HOST");
      let urlToCopy = baseUrl + '/pub/academy/' + this.$store.state.selectedAcademy + '/calendar?schedule_visit=true';
      if (!link) {
        this.currentQRCode = { title: this.$t("message.schedule_visit"), url: urlToCopy, type: 'new_visit' };
        this.viewQRDialog = true;
      } else {
        this.copyToClipboard(urlToCopy);
      }
    },
    openScheduleQr(link) {
      const baseUrl = Environment.get("VUE_APP_API_HOST");
      let urlToCopy = baseUrl + '/pub/academy/' + this.$store.state.selectedAcademy + '/schedule?mode=flat';
      if (!link) {
        this.currentQRCode = { title: this.$t("message.academy_schedule"), url: urlToCopy, type: 'schedule' };
        this.viewQRDialog = true;
      } else {
        this.copyToClipboard(urlToCopy);
      }
    },
    openPMPQr(link) {
      const baseUrl = Environment.get("VUE_APP_API_HOST");
      let urlToCopy = baseUrl + '/pub/academy/' + this.$store.state.selectedAcademy + '/memberships?embed=false';
      if (!link) {
        this.currentQRCode = { title: this.$t("message.public_memberships_page"), url: urlToCopy, type: 'memberships' };
        this.viewQRDialog = true;
      } else {
        this.copyToClipboard(urlToCopy);
      }
    },
    selectEmailTemplate(v) {
      if (v) {
        Api()
          .get(
            "documents/academy/" +
            this.$store.state.managedAcademy +
            "/email/templates/" +
            v
          )
          .then((response) => {
            if (response) {
              const template = response.data.template;
              this.editor = template.contents;
              this.subject = template.subject;
            }
          })
          .catch(() => {
            this.showAlert("error", "Oops!", this.$t("message.error_generic"));
          });
      }
    },
    getUsersCSV(list) {
      Api()
        .get(
          "admins/academy/" +
          this.$store.state.managedAcademy +
          "/export/csv/" + list
        )
        .then((response) => {
          let blob = new Blob([response.data], { type: "text/csv" });
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = list + "_" + new Date().toISOString() + "_" + ".csv";
          link.click();
        })
        .catch((e) => {
          if (e)
            this.showAlert("error", "Oops!", this.$t("message.error_generic"));
        });
    },
    copyScheduleVisitUrl() {
      const baseUrl = Environment.get("VUE_APP_API_HOST");
      const urlToCopy = baseUrl + '/pub/academy/' + this.$store.state.selectedAcademy + '/calendar?schedule_visit=true';
      this.copyToClipboard(urlToCopy);
    },
    getAvailableTags() {
      Api()
        .get("admins/academy/" + this.$store.state.selectedAcademy + "/tags")
        .then((response) => {
          if (response.data) {
            this.availableTags = response.data.sort();
          }
        })
        .catch((e) => {
          this.loading = false;
          if (e)
            this.showAlert("error", "Oops!", this.$t("message.error_generic"));
        });
    },
    selectAll: function () {
      if (!this.allSelected) {
        this.allSelected = true;
        for (var i of this.filteredVisitors) {
          //i.selected = true;
          this.selectedItems.push(i);
        }
      } else {
        this.allSelected = false;
        this.selectedItems = [];
      }
    },
    getEmailTemplates() {
      Api()
        .get(
          "documents/academy/" + this.$store.state.managedAcademy + "/email/templates?archived=false"
        )
        .then((response) => {
          if (response) {
            if (response.data.templates && response.data.templates.length > 0)
              this.emailTemplates = response.data.templates;
          }
        });
    },
    openSendEmailDialog() {
      this.getEmailTemplates();
      if (this.selectedItems && this.selectedItems.length > 0)
        this.sendEmailsDialog = true;
      else
        this.showAlert("info", this.$t("message.at_least_one_member"));
    },
    displayNewProspectDialog() {
      this.newProspectDialog = true;
    },
    getInquiries(initialLoad) {
      this.loadingList = true;
      let params = {};
      if (this.iTagsFilter)
        params.tags = this.iTagsFilter;
      Api()
        .post("admins/academy/" + this.$store.state.managedAcademy + "/inquiries", params)
        .then((response) => {
          if (response.data) {
            this.inquiries = response.data.list;
            this.filteredInquiries = this.inquiries;
            this.loadingList = false;
          }
        });
      if (initialLoad)
        Api()
          .post("admins/academy/" + this.$store.state.managedAcademy + "/inquiries", { archived: true })
          .then((response) => {
            if (response.data) {
              let list = [];
              if (response.data.list && response.data.list.length) {
                for (const i of response.data.list) {
                  list.push({ value: i._id, text: i.name + ' (' + i.email + ')' });
                }
                this.archivedInquiries = list;
              }
            }
          });
    },
    removeProspect(p) {
      Api()
        .delete("admins/academy/" + this.$store.state.managedAcademy + "/prospects/" + p._id)
        .then((response) => {
          if (response.data) {
            this.getInquiries();
          }
        });
    },
    async sendEmailToUsers() {
      this.sendingEmails = true;
      let recipients = [];
      let postData = {};
      if (this.selectedItems) {
        for (const r of this.selectedItems) {
          if (r._id) recipients.push(r._id);
        }
      }
      if (recipients.length > 0 && this.editor != "" && this.subject != "") {
        postData.recipients = recipients;
        postData.subject = this.subject;
        postData.contents = this.editor;
        postData.emailTemplate = this.selectedEmailTemplate;
        //console.log(postData.contents);
        const regexp = /data:image\/([a-zA-Z]*);base64,([^"]*)/g;
        let totalImages = 0;
        const groups = this.findMatches(postData.contents, regexp);
        const replacements = [];

        if (groups.length >= 1) {
          let increaseBy = Math.round((100 - this.processingImagesProgress) / (totalImages + 1));
          this.processingImages = true;
          for (const group of groups) {
            try {
              const formData = new FormData();
              const d = new Date();
              const millis = d.getTime();

              const blob = this.blobFromBase64(group);
              formData.append("image", blob, 'bjjlink-user-admin-uploaded-image-' + millis + '.jpg');
              const res = await Api()
                .post("content/image/admin", formData);
              const data = res.data;
              if (data) {
                replacements.push(data.location);
                this.processingImagesProgress += increaseBy;
              }
            } catch (err) {
              console.log(err);
              this.processingImages = false;
              this.showAlert("error", "Error processing images");
              return;
            }
          }
          this.processingImagesProgress = 100;
          postData.contents = this.replaceMatches(postData.contents, regexp, replacements);
        }
        this.postEmail(postData);
      } else {
        this.sendingEmails = false;
        this.processingImages = false;
        this.showAlert("info", this.$t("message.fill_all_params"), ":(");
      }
    },
    postEmail(emailData) {
      this.processingImages = false;
      Api()
        .post(
          "admins/v2/academy/" +
          this.$store.state.managedAcademy +
          "/prospects/send/emails",
          emailData
        )
        .then((response) => {
          this.showAlert("success", "Oss!", ":)");
          if (response.data) {
            this.sendEmailsDialog = false;
            this.selectedItems = [];
            this.sendingEmails = false;
            this.subject = "";
            this.editor = null;
            this.selectedEmailTemplate = null;
          }
        })
        .catch((e) => {
          this.sendingEmails = false;
          if (e)
            this.showAlert("error", "Oops!", this.$t("message.error_generic"));
        });
    },
    addNewProspect() {
      this.addingInquiry = true;
      if (!this.archivedInquiry && (!this.newProspect.name || !this.newProspect.email)) {
        this.showAlert("error", this.$t("message.fill_all_params"));
      } else {
        if (this.archivedInquiry) {
          this.newProspect = { archived: true, _id: this.archivedInquiry };
        }
        Api()
          .post(
            "admins/academy/" + this.$store.state.managedAcademy + "/prospects", this.newProspect
          )
          .then((response) => {
            if (response.data) {
              this.newProspectDialog = false;
              this.newProspect = {};
              this.getInquiries();
              this.addingInquiry = false;
            }
          }).catch((err) => {
            if (err.response && err.response.status === 409) {
              this.showAlert("error", this.$t("message.existing_user"));
            } else {
              this.showAlert("error", this.$t("message.error_generic"));
            }
            this.addingInquiry = false;
          });
      }
    },
    clickTab(tab) {
      if (tab != this.activeTab) {
        this.selectedItems = [];
        this.navigateTo({
          name: "growthcentraltab",
          params: { tabId: tab },
        });
        if (tab == 5)
          this.getAffiliates();
      }
    },
    getAffiliates() {
      Api()
        .get("referrals/managedacademy/" + this.$store.state.managedAcademy + "/affiliates")
        .then((response) => {
          if (response.data && response.data.data) {
            this.affiliates = response.data.data;
            this.campaigns = response.data.campaigns;
            this.filteredAffiliates = this.affiliates;
          }
        });
    },
    getVisitors() {
      this.loadingList = true;
      let params = {};
      if (this.vTagsFilter)
        params.tags = this.vTagsFilter;
      Api()
        .post("admins/academy/" + this.$store.state.managedAcademy + "/visitors", params)
        .then((response) => {
          if (response.data && response.data.list) {
            this.visitors = response.data.list;
            this.filteredVisitors = this.visitors;
            this.loadingList = false;
          }
        });
    },
    getLeads() {
      this.loadingList = true;
      let params = {};
      if (this.lTagsFilter)
        params.tags = this.lTagsFilter;
      Api()
        .post("admins/academy/" + this.$store.state.managedAcademy + "/leads", params)
        .then((response) => {
          if (response.data && response.data.list) {
            this.leads = response.data.list;
            this.filteredLeads = this.leads;
            this.loadingList = false;
          }
        });
    },
    showProspectToVisitorDialog(prospect) {
      if (prospect) {
        this.prospectToVisitorDialog = true;
        this.selectedProspectId = prospect._id;
      }
    },
    prospectToVisitor() {
      if (this.selectedProspectId) {
        const d = this.newVisitDate;
        Api()
          .post("admins/academy/" + this.$store.state.managedAcademy + "/new_visitor/prospect/" + this.selectedProspectId, { date: d })
          .then((response) => {
            try {
              if (response.data) {
                this.prospectToVisitorDialog = false;
                this.selectedProspectId = null;
                this.getInquiries();
                this.getVisitors();
              }
            } catch (e) {
              console.log(e);
            }
          })
          .catch((e) => {
            this.registring = false;
            if (e)
              this.showAlert("error", "Oops!", "Error :(");
          });
      }
    },
    prospectToMemberDialog(prospect) {
      if (prospect) {
        this.newUser = {};
        this.newUser.email = prospect.email;
        this.newUser.gender = prospect.gender;
        this.newUser.phone = prospect.phone;
        this.newUser.nationality = prospect.nationality;
        this.newUserDialog = true;
        const split = prospect.name.split(' ');
        this.newUser.fName = split[0];
        this.newUser.lName = split[1] + (split[2] ? ' ' + split[2] : '');
        this.newUser.visitorId = prospect._id;
      }
    },
    archiveVisitor() {
      if (this.selectedVisitor) {
        Api()
          .delete("admins/academy/" + this.$store.state.managedAcademy + "/visitors/" + this.selectedVisitor._id)
          .then((response) => {
            if (response.data) {
              this.getVisitors();
              this.archiveVisitorDialog = false;
              this.selectedVisitor = null;
            }
          });
      }
    },
    showArchiveVisitorDialog(visitor) {
      this.archiveVisitorDialog = true;
      this.selectedVisitor = visitor;
    },
    visitorToMemberDialog(visitor) {
      if (visitor) {
        this.newUser = {};
        if (visitor.user) {
          Api()
            .post("admins/academy/" + this.$store.state.managedAcademy + "/new_member/visitor/" + visitor._id)
            .then((response) => {
              try {
                if (response.data) {
                  this.newUserDialog = false;
                  this.registring = false;
                  this.approveMember(response.data, false);
                  this.showAlert("success");
                }
              } catch (e) {
                console.log(e);
              }
            })
            .catch((e) => {
              this.registring = false;
              if (e)
                this.showAlert("error", "Oops!", "Error :(");
            });
          return;
        } else {
          if (visitor.name) {
            const split = visitor.name.split(' ');
            if (split) {
              if (split[0])
                this.newUser.fName = split[0];
              if (split[1])
                this.newUser.lName = split[1];
            }
          }
          this.newUser.email = visitor.email;
          this.newUserDialog = true;
          this.newUser.visitorId = visitor._id;
        }
      }
    },
  },
};
</script>

<style scoped>
.stat-number {
  font-size: 3em;
  font-weight: 600;
}

.growth-stat {
  height: 100%
}
</style>
